function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    // document.querySelectorAll('[id^="Details-"] summary').forEach((sum) => {
    //   sum.setAttribute('aria-expanded',false);
    // })
    // document.querySelectorAll('[id^="Details-"]').forEach((sum) => {
    //   sum.removeAttribute('open');
    // })

    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    // this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
    //   details.removeAttribute('open');
    //   details.classList.remove('menu-opening');
    // });
    // this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
    //   submenu.classList.remove('submenu-open');
    // });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    
    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    if (!this.sliderControlWrapper) return;
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

    
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    
    
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
  
  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.slider.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);



class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
          document.dispatchEvent(
            new CustomEvent('recommend-slider', { bubbles: true, cancelable: false })
          );
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function throttle(callback, delay3 = 15) {
  let throttleTimeout = null, storedEvent = null;
  const throttledEventHandler = (event) => {
    storedEvent = event;
    const shouldHandleEvent = !throttleTimeout;
    if (shouldHandleEvent) {
      callback(storedEvent);
      storedEvent = null;
      throttleTimeout = setTimeout(() => {
        throttleTimeout = null;
        if (storedEvent) {
          throttledEventHandler(storedEvent);
        }
      }, delay3);
    }
  };
  return throttledEventHandler;
}

function triggerEvent(element, name, data = {}) {
  element.dispatchEvent(new CustomEvent(name, {
    bubbles: true,
    detail: data
  }));
}
function triggerNonBubblingEvent(element, name, data = {}) {
  element.dispatchEvent(new CustomEvent(name, {
    bubbles: false,
    detail: data
  }));
}


var CustomHTMLElement = class extends HTMLElement {
  constructor() {
    super();
    this._hasSectionReloaded = false;
    if (Shopify.designMode) {
      this.rootDelegate.on("shopify:section:select", (event) => {
        const parentSection = this.closest(".shopify-section");
        if (event.target === parentSection && event.detail.load) {
          this._hasSectionReloaded = true;
        }
      });
    }
  }
  get rootDelegate() {
    return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
  }
  get delegate() {
    return this._delegate = this._delegate || new main_default(this);
  }
  showLoadingBar() {
    triggerEvent(document.documentElement, "theme:loading:start");
  }
  hideLoadingBar() {
    triggerEvent(document.documentElement, "theme:loading:end");
  }
  untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
    const onBecameVisible = () => {
      this.classList.add("became-visible");
      this.style.opacity = "1";
    };
    return new Promise((resolve) => {
      if (window.IntersectionObserver) {
        this.intersectionObserver = new IntersectionObserver((event) => {
          if (event[0].isIntersecting) {
            this.intersectionObserver.disconnect();
            requestAnimationFrame(() => {
              resolve();
              onBecameVisible();
            });
          }
        }, intersectionObserverOptions);
        this.intersectionObserver.observe(this);
      } else {
        resolve();
        onBecameVisible();
      }
    });
  }
  disconnectedCallback() {
    var _a;
    this.delegate.destroy();
    this.rootDelegate.destroy();
    (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
    delete this._delegate;
    delete this._rootDelegate;
  }
};

var CustomAnimation = class {
  constructor(effect) {
    this._effect = effect;
    this._playState = "idle";
    this._finished = Promise.resolve();
  }
  get finished() {
    return this._finished;
  }
  get animationEffects() {
    return this._effect instanceof CustomKeyframeEffect ? [this._effect] : this._effect.animationEffects;
  }
  cancel() {
    this.animationEffects.forEach((animationEffect) => animationEffect.cancel());
  }
  finish() {
    this.animationEffects.forEach((animationEffect) => animationEffect.finish());
  }
  play() {
    this._playState = "running";
    this._effect.play();
    this._finished = this._effect.finished;
    this._finished.then(() => {
      this._playState = "finished";
    }, (rejection) => {
      this._playState = "idle";
    });
  }
};
var CustomKeyframeEffect = class {
  constructor(target, keyframes, options = {}) {
    if (!target) {
      return;
    }
    if ("Animation" in window) {
      this._animation = new Animation(new KeyframeEffect(target, keyframes, options));
    } else {
      options["fill"] = "forwards";
      this._animation = target.animate(keyframes, options);
      this._animation.pause();
    }
    this._animation.addEventListener("finish", () => {
      target.style.opacity = keyframes.hasOwnProperty("opacity") ? keyframes["opacity"][keyframes["opacity"].length - 1] : null;
      target.style.visibility = keyframes.hasOwnProperty("visibility") ? keyframes["visibility"][keyframes["visibility"].length - 1] : null;
    });
  }
  get finished() {
    if (!this._animation) {
      return Promise.resolve();
    }
    return this._animation.finished ? this._animation.finished : new Promise((resolve) => this._animation.onfinish = resolve);
  }
  play() {
    if (this._animation) {
      this._animation.startTime = null;
      this._animation.play();
    }
  }
  cancel() {
    if (this._animation) {
      this._animation.cancel();
    }
  }
  finish() {
    if (this._animation) {
      this._animation.finish();
    }
  }
};
var GroupEffect = class {
  constructor(childrenEffects) {
    this._childrenEffects = childrenEffects;
    this._finished = Promise.resolve();
  }
  get finished() {
    return this._finished;
  }
  get animationEffects() {
    return this._childrenEffects.flatMap((effect) => {
      return effect instanceof c ? effect : effect.animationEffects;
    });
  }
};
var ParallelEffect = class extends GroupEffect {
  play() {
    const promises = [];
    for (const effect of this._childrenEffects) {
      effect.play();
      promises.push(effect.finished);
    }
    this._finished = Promise.all(promises);
  }
};
var SequenceEffect = class extends GroupEffect {
  play() {
    this._finished = new Promise(async (resolve, reject) => {
      try {
        for (const effect of this._childrenEffects) {
          effect.play();
          await effect.finished;
        }
        resolve();
      } catch (exception) {
        reject();
      }
    });
  }
};

  
var TabsNav = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll("button[aria-controls]"));
    this.scrollerElement = this.querySelector(".tabs-nav__scroller");
    this.buttons.forEach((button) => button.addEventListener("click", () => this.selectButton(button)));
    this.addEventListener("shopify:block:select", (event) => this.selectButton(event.target, !event.detail.load));
    this.positionElement = document.createElement("span");
    this.positionElement.classList.add("tabs-nav__position");
    this.buttons[0].parentElement.insertAdjacentElement("afterend", this.positionElement);
    window.addEventListener("resize", this._onWindowResized.bind(this));
    this._adjustNavigationPosition();
    if (this.hasArrows) {
      this._handleArrows();
    }
  }
  get hasArrows() {
    return this.hasAttribute("arrows");
  }
  get selectedTabIndex() {
    return this.buttons.findIndex((button) => button.getAttribute("aria-expanded") === "true");
  }
  get selectedButton() {
    return this.buttons.find((button) => button.getAttribute("aria-expanded") === "true");
  }
  selectButton(button, animate = true) {
    if (!this.buttons.includes(button) || this.selectedButton === button) {
      return;
    }
    const from = document.getElementById(this.selectedButton.getAttribute("aria-controls")), to = document.getElementById(button.getAttribute("aria-controls"));
    
    if (animate) {
      this._transitionContent(from, to);
    } else {
      from.hidden = true;
      to.hidden = false;
    }
    this.selectedButton.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-expanded", "true");
    triggerEvent(this, "tabs-nav:changed", { button });
    this._adjustNavigationPosition();
  }
  addButton(button) {
    button.addEventListener("click", () => this.selectButton(button));
    button.setAttribute("aria-expanded", "false");    
    this.buttons[this.buttons.length - 1].insertAdjacentElement("afterend", button);
    this.buttons.push(button);
    this._adjustNavigationPosition(false);
  }
  _transitionContent(from, to) {
    from.animate({
      opacity: [1, 0]
    }, {
      duration: 250,
      easing: "ease"
    }).onfinish = () => {
      from.hidden = true;
      to.hidden = false;
      to.animate({
        opacity: [0, 1]
      }, {
        duration: 250,
        easing: "ease"
      });
    };
  }
  _onWindowResized() {
    this._adjustNavigationPosition();
  }
  _adjustNavigationPosition(shouldAnimate = true) {
    const scale = this.selectedButton.clientWidth / this.positionElement.parentElement.clientWidth, translate = this.selectedButton.offsetLeft / this.positionElement.parentElement.clientWidth / scale, windowHalfWidth = this.scrollerElement.clientWidth / 2;
    this.scrollerElement.scrollTo({
      behavior: shouldAnimate ? "smooth" : "auto",
      left: this.selectedButton.offsetLeft - windowHalfWidth + this.selectedButton.clientWidth / 2
    });
    if (!shouldAnimate) {
      this.positionElement.style.transition = "none";
    }
    this.positionElement.style.setProperty("--scale", scale);
    this.positionElement.style.setProperty("--translate", `${translate * 100}%`);
    this.positionElement.clientWidth;
    requestAnimationFrame(() => {
      this.positionElement.classList.add("is-initialized");
      this.positionElement.style.transition = null;
    });
  }
  _handleArrows() {
    const arrowsContainer = this.querySelector(".tabs-nav__arrows");
    arrowsContainer.firstElementChild.addEventListener("click", () => {
      console.log("1");
      this.selectButton(this.buttons[Math.max(this.selectedTabIndex - 1, 0)]);
    });
    arrowsContainer.lastElementChild.addEventListener("click", () => {
      console.log("1");
      this.selectButton(this.buttons[Math.min(this.selectedTabIndex + 1, this.buttons.length - 1)]);
    });
  }
};
window.customElements.define("tabs-nav", TabsNav);


var ScrollableContent = class extends CustomHTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this.draggable) {
      this._setupDraggability();
    }
    this._checkScrollability();
    window.addEventListener("resize", this._checkScrollability.bind(this));
    this.addEventListener("scroll", throttle(this._calculateProgress.bind(this), 15));
  }
  get draggable() {
    return this.hasAttribute("draggable");
  }
  _setupDraggability() {
    this.insertAdjacentHTML("afterend", '<drag-cursor hidden class="custom-drag-cursor"></drag-cursor>');
    const mediaQuery = matchMedia("(hover: none)");
    mediaQuery.addListener(this._onMediaChanges.bind(this));
    if (!mediaQuery.matches) {
      this._attachDraggableListeners();
    }
  }
  _attachDraggableListeners() {
    this.delegate.on("mousedown", this._onMouseDown.bind(this));
    this.delegate.on("mousemove", this._onMouseMove.bind(this));
    this.delegate.on("mouseup", this._onMouseUp.bind(this));
  }
  _removeDraggableListeners() {
    this.delegate.off("mousedown");
    this.delegate.off("mousemove");
    this.delegate.off("mouseup");
  }
  _checkScrollability() {
    this.classList.toggle("is-scrollable", this.scrollWidth > this.offsetWidth);
  }
  _calculateProgress() {
    const scrollLeft = this.scrollLeft * (window.themeVariables.settings.direction === "ltr" ? 1 : -1);
    const progress = Math.max(0, Math.min(1, scrollLeft / (this.scrollWidth - this.clientWidth))) * 100;
    triggerEvent(this, "scrollable-content:progress", { progress });
  }
  _onMediaChanges(event) {
    if (!event.matches) {
      this._attachDraggableListeners();
    } else {
      this._removeDraggableListeners();
    }
  }
  _onMouseDown(event) {
    if (event.target && event.target.nodeName === "IMG") {
      event.preventDefault();
    }
    this.startX = event.clientX + this.scrollLeft;
    this.diffX = 0;
    this.drag = true;
  }
  _onMouseMove(event) {
    if (this.drag) {
      this.diffX = this.startX - (event.clientX + this.scrollLeft);
      this.scrollLeft += this.diffX;
    }
  }
  _onMouseUp() {
    this.drag = false;
    let start = 1;
    let animate = () => {
      let step = Math.sinh(start);
      if (step <= 0) {
        window.cancelAnimationFrame(animate);
      } else {
        this.scrollLeft += this.diffX * step;
        start -= 0.03;
        window.requestAnimationFrame(animate);
      }
    };
    animate();
  }
};
window.customElements.define("scrollable-content", ScrollableContent);

var Fi = Object.create;
var Ce = Object.defineProperty;
var Li = Object.getOwnPropertyDescriptor;
var Ci = Object.getOwnPropertyNames;
var Ri = Object.getPrototypeOf,
    Mi = Object.prototype.hasOwnProperty;
var ki = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports),
    zi = (e, t) => {
        for (var r in t) Ce(e, r, { get: t[r], enumerable: !0 });
    },
    ji = (e, t, r, i) => {
        if ((t && typeof t == "object") || typeof t == "function") for (let n of Ci(t)) !Mi.call(e, n) && n !== r && Ce(e, n, { get: () => t[n], enumerable: !(i = Li(t, n)) || i.enumerable });
        return e;
    };
var $i = (e, t, r) => ((r = e != null ? Fi(Ri(e)) : {}), ji(t || !e || !e.__esModule ? Ce(r, "default", { value: e, enumerable: !0 }) : r, e));
var Rr = ki(() => {
    (function () {
        "use strict";
        var e = function (h, c) {
            var p = function (D) {
                    for (var E = 0, N = D.length; E < N; E++) b(D[E]);
                },
                b = function (D) {
                    var E = D.target,
                        N = D.attributeName,
                        K = D.oldValue;
                    E.attributeChangedCallback(N, K, E.getAttribute(N));
                };
            return function (w, D) {
                var E = w.constructor.observedAttributes;
                return (
                    E &&
                        h(D).then(function () {
                            new c(p).observe(w, { attributes: !0, attributeOldValue: !0, attributeFilter: E });
                            for (var N = 0, K = E.length; N < K; N++) w.hasAttribute(E[N]) && b({ target: w, attributeName: E[N], oldValue: null });
                        }),
                    w
                );
            };
        };
        function t(h, c) {
            if (h) {
                if (typeof h == "string") return r(h, c);
                var p = Object.prototype.toString.call(h).slice(8, -1);
                if ((p === "Object" && h.constructor && (p = h.constructor.name), p === "Map" || p === "Set")) return Array.from(h);
                if (p === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(p)) return r(h, c);
            }
        }
        function r(h, c) {
            (c == null || c > h.length) && (c = h.length);
            for (var p = 0, b = new Array(c); p < c; p++) b[p] = h[p];
            return b;
        }
        function i(h, c) {
            var p = (typeof Symbol < "u" && h[Symbol.iterator]) || h["@@iterator"];
            if (!p) {
                if (Array.isArray(h) || (p = t(h)) || (c && h && typeof h.length == "number")) {
                    p && (h = p);
                    var b = 0,
                        w = function () {};
                    return {
                        s: w,
                        n: function () {
                            return b >= h.length ? { done: !0 } : { done: !1, value: h[b++] };
                        },
                        e: function (K) {
                            throw K;
                        },
                        f: w,
                    };
                }
                throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var D = !0,
                E = !1,
                N;
            return {
                s: function () {
                    p = p.call(h);
                },
                n: function () {
                    var K = p.next();
                    return (D = K.done), K;
                },
                e: function (K) {
                    (E = !0), (N = K);
                },
                f: function () {
                    try {
                        !D && p.return != null && p.return();
                    } finally {
                        if (E) throw N;
                    }
                },
            };
        }
        var n = !0,
            s = !1,
            o = "querySelectorAll",
            u = function (c) {
                var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document,
                    b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : MutationObserver,
                    w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ["*"],
                    D = function K(pt, mt, Q, O, $, U) {
                        var J = i(pt),
                            Dt;
                        try {
                            for (J.s(); !(Dt = J.n()).done; ) {
                                var Z = Dt.value;
                                (U || o in Z) && ($ ? Q.has(Z) || (Q.add(Z), O.delete(Z), c(Z, $)) : O.has(Z) || (O.add(Z), Q.delete(Z), c(Z, $)), U || K(Z[o](mt), mt, Q, O, $, n));
                            }
                        } catch (Le) {
                            J.e(Le);
                        } finally {
                            J.f();
                        }
                    },
                    E = new b(function (K) {
                        if (w.length) {
                            var pt = w.join(","),
                                mt = new Set(),
                                Q = new Set(),
                                O = i(K),
                                $;
                            try {
                                for (O.s(); !($ = O.n()).done; ) {
                                    var U = $.value,
                                        J = U.addedNodes,
                                        Dt = U.removedNodes;
                                    D(Dt, pt, mt, Q, s, s), D(J, pt, mt, Q, n, s);
                                }
                            } catch (Z) {
                                O.e(Z);
                            } finally {
                                O.f();
                            }
                        }
                    }),
                    N = E.observe;
                return (
                    (E.observe = function (K) {
                        return N.call(E, K, { subtree: n, childList: n });
                    })(p),
                    E
                );
            },
            d = "querySelectorAll",
            f = self,
            y = f.document,
            m = f.Element,
            v = f.MutationObserver,
            _ = f.Set,
            z = f.WeakMap,
            j = function (c) {
                return d in c;
            },
            R = [].filter,
            B = function (h) {
                var c = new z(),
                    p = function (O) {
                        for (var $ = 0, U = O.length; $ < U; $++) c.delete(O[$]);
                    },
                    b = function () {
                        for (var O = pt.takeRecords(), $ = 0, U = O.length; $ < U; $++) E(R.call(O[$].removedNodes, j), !1), E(R.call(O[$].addedNodes, j), !0);
                    },
                    w = function (O) {
                        return O.matches || O.webkitMatchesSelector || O.msMatchesSelector;
                    },
                    D = function (O, $) {
                        var U;
                        if ($) for (var J, Dt = w(O), Z = 0, Le = N.length; Z < Le; Z++) Dt.call(O, (J = N[Z])) && (c.has(O) || c.set(O, new _()), (U = c.get(O)), U.has(J) || (U.add(J), h.handle(O, $, J)));
                        else
                            c.has(O) &&
                                ((U = c.get(O)),
                                c.delete(O),
                                U.forEach(function (Pi) {
                                    h.handle(O, $, Pi);
                                }));
                    },
                    E = function (O) {
                        for (var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, U = 0, J = O.length; U < J; U++) D(O[U], $);
                    },
                    N = h.query,
                    K = h.root || y,
                    pt = u(D, K, v, N),
                    mt = m.prototype.attachShadow;
                return (
                    mt &&
                        (m.prototype.attachShadow = function (Q) {
                            var O = mt.call(this, Q);
                            return pt.observe(O), O;
                        }),
                    N.length && E(K[d](N)),
                    { drop: p, flush: b, observer: pt, parse: E }
                );
            },
            P = self,
            F = P.document,
            C = P.Map,
            Y = P.MutationObserver,
            k = P.Object,
            tt = P.Set,
            T = P.WeakMap,
            et = P.Element,
            A = P.HTMLElement,
            S = P.Node,
            a = P.Error,
            l = P.TypeError,
            g = P.Reflect,
            x = k.defineProperty,
            I = k.keys,
            L = k.getOwnPropertyNames,
            M = k.setPrototypeOf,
            W = !self.customElements,
            H = function (c) {
                for (var p = I(c), b = [], w = new tt(), D = p.length, E = 0; E < D; E++) {
                    b[E] = c[p[E]];
                    try {
                        delete c[p[E]];
                    } catch {
                        w.add(E);
                    }
                }
                return function () {
                    for (var N = 0; N < D; N++) w.has(N) || (c[p[N]] = b[N]);
                };
            };
        if (W) {
            var nt = function () {
                    var c = this.constructor;
                    if (!rt.has(c)) throw new l("Illegal constructor");
                    var p = rt.get(c);
                    if (Qt) return nr(Qt, p);
                    var b = ht.call(F, p);
                    return nr(M(b, c.prototype), p);
                },
                ht = F.createElement,
                rt = new C(),
                st = new C(),
                Lt = new C(),
                ct = new C(),
                Nt = [],
                gi = function (c, p, b) {
                    var w = Lt.get(b);
                    if (p && !w.isPrototypeOf(c)) {
                        var D = H(c);
                        Qt = M(c, w);
                        try {
                            new w.constructor();
                        } finally {
                            (Qt = null), D();
                        }
                    }
                    var E = "".concat(p ? "" : "dis", "connectedCallback");
                    E in w && c[E]();
                },
                yi = B({ query: Nt, handle: gi }),
                bi = yi.parse,
                Qt = null,
                _e = function (c) {
                    if (!st.has(c)) {
                        var p,
                            b = new Promise(function (w) {
                                p = w;
                            });
                        st.set(c, { $: b, _: p });
                    }
                    return st.get(c).$;
                },
                nr = e(_e, Y);
            (self.customElements = {
                define: function (c, p) {
                    if (ct.has(c)) throw new a('the name "'.concat(c, '" has already been used with this registry'));
                    rt.set(p, c),
                        Lt.set(c, p.prototype),
                        ct.set(c, p),
                        Nt.push(c),
                        _e(c).then(function () {
                            bi(F.querySelectorAll(c));
                        }),
                        st.get(c)._(p);
                },
                get: function (c) {
                    return ct.get(c);
                },
                whenDefined: _e,
            }),
                x((nt.prototype = A.prototype), "constructor", { value: nt }),
                (self.HTMLElement = nt),
                (F.createElement = function (h, c) {
                    var p = c && c.is,
                        b = p ? ct.get(p) : ct.get(h);
                    return b ? new b() : ht.call(F, h);
                }),
                "isConnected" in S.prototype ||
                    x(S.prototype, "isConnected", {
                        configurable: !0,
                        get: function () {
                            return !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
                        },
                    });
        } else if (((W = !self.customElements.get("extends-br")), W))
            try {
                var or = function h() {
                    return self.Reflect.construct(HTMLBRElement, [], h);
                };
                or.prototype = HTMLLIElement.prototype;
                var sr = "extends-br";
                self.customElements.define("extends-br", or, { extends: "br" }), (W = F.createElement("br", { is: sr }).outerHTML.indexOf(sr) < 0);
                var ar = self.customElements,
                    wi = ar.get,
                    Ei = ar.whenDefined;
                self.customElements.whenDefined = function (h) {
                    var c = this;
                    return Ei.call(this, h).then(function (p) {
                        return p || wi.call(c, h);
                    });
                };
            } catch {}
        if (W) {
            var lr = function (c) {
                    var p = Ne.get(c);
                    hr(p.querySelectorAll(this), c.isConnected);
                },
                at = self.customElements,
                cr = F.createElement,
                xi = at.define,
                Si = at.get,
                Oi = at.upgrade,
                Ti = g || {
                    construct: function (c) {
                        return c.call(this);
                    },
                },
                Ai = Ti.construct,
                Ne = new T(),
                De = new tt(),
                Jt = new C(),
                te = new C(),
                ur = new C(),
                ee = new C(),
                fr = [],
                re = [],
                dr = function (c) {
                    return ee.get(c) || Si.call(at, c);
                },
                Ii = function (c, p, b) {
                    var w = ur.get(b);
                    if (p && !w.isPrototypeOf(c)) {
                        var D = H(c);
                        ie = M(c, w);
                        try {
                            new w.constructor();
                        } finally {
                            (ie = null), D();
                        }
                    }
                    var E = "".concat(p ? "" : "dis", "connectedCallback");
                    E in w && c[E]();
                },
                _i = B({ query: re, handle: Ii }),
                hr = _i.parse,
                Ni = B({
                    query: fr,
                    handle: function (c, p) {
                        Ne.has(c) && (p ? De.add(c) : De.delete(c), re.length && lr.call(re, c));
                    },
                }),
                Di = Ni.parse,
                pr = et.prototype.attachShadow;
            pr &&
                (et.prototype.attachShadow = function (h) {
                    var c = pr.call(this, h);
                    return Ne.set(this, c), c;
                });
            var Pe = function (c) {
                    if (!te.has(c)) {
                        var p,
                            b = new Promise(function (w) {
                                p = w;
                            });
                        te.set(c, { $: b, _: p });
                    }
                    return te.get(c).$;
                },
                Fe = e(Pe, Y),
                ie = null;
            L(self)
                .filter(function (h) {
                    return /^HTML.*Element$/.test(h);
                })
                .forEach(function (h) {
                    var c = self[h];
                    function p() {
                        var b = this.constructor;
                        if (!Jt.has(b)) throw new l("Illegal constructor");
                        var w = Jt.get(b),
                            D = w.is,
                            E = w.tag;
                        if (D) {
                            if (ie) return Fe(ie, D);
                            var N = cr.call(F, E);
                            return N.setAttribute("is", D), Fe(M(N, b.prototype), D);
                        } else return Ai.call(this, c, [], b);
                    }
                    x((p.prototype = c.prototype), "constructor", { value: p }), x(self, h, { value: p });
                }),
                (F.createElement = function (h, c) {
                    var p = c && c.is;
                    if (p) {
                        var b = ee.get(p);
                        if (b && Jt.get(b).tag === h) return new b();
                    }
                    var w = cr.call(F, h);
                    return p && w.setAttribute("is", p), w;
                }),
                (at.get = dr),
                (at.whenDefined = Pe),
                (at.upgrade = function (h) {
                    var c = h.getAttribute("is");
                    if (c) {
                        var p = ee.get(c);
                        if (p) {
                            Fe(M(h, p.prototype), c);
                            return;
                        }
                    }
                    Oi.call(at, h);
                }),
                (at.define = function (h, c, p) {
                    if (dr(h)) throw new a("'".concat(h, "' has already been defined as a custom element"));
                    var b,
                        w = p && p.extends;
                    Jt.set(c, w ? { is: h, tag: w } : { is: "", tag: h }),
                        w ? ((b = "".concat(w, '[is="').concat(h, '"]')), ur.set(b, c.prototype), ee.set(h, c), re.push(b)) : (xi.apply(at, arguments), fr.push((b = h))),
                        Pe(h).then(function () {
                            w ? (hr(F.querySelectorAll(b)), De.forEach(lr, [b])) : Di(F.querySelectorAll(b));
                        }),
                        te.get(h)._(c);
                });
        }
    })();
});
var ne = null,
    vr,
    gr,
    yr,
    br = 65,
    Re,
    Ct,
    mr = new Set(),
    wr = 1111;
Wi();
function Wi() {
    if (!document.createElement("link").relList.supports("prefetch")) return;
    let t = "instantVaryAccept" in document.body.dataset || "Shopify" in window,
        r = navigator.userAgent.indexOf("Chrome/");
    if ((r > -1 && (ne = parseInt(navigator.userAgent.substring(r + 7))), t && ne && ne < 110)) return;
    let i = "instantMousedownShortcut" in document.body.dataset;
    (vr = "instantAllowQueryString" in document.body.dataset), (gr = "instantAllowExternalLinks" in document.body.dataset), (yr = "instantWhitelist" in document.body.dataset);
    let n = { capture: !0, passive: !0 },
        s = !1,
        o = !1,
        u = !1;
    if ("instantIntensity" in document.body.dataset) {
        let d = document.body.dataset.instantIntensity;
        if (d.startsWith("mousedown")) (s = !0), d == "mousedown-only" && (o = !0);
        else if (d.startsWith("viewport")) {
            let f = navigator.connection && navigator.connection.saveData,
                y = navigator.connection && navigator.connection.effectiveType && navigator.connection.effectiveType.includes("2g");
            !f && !y && (d == "viewport" ? document.documentElement.clientWidth * document.documentElement.clientHeight < 45e4 && (u = !0) : d == "viewport-all" && (u = !0));
        } else {
            let f = parseInt(d);
            isNaN(f) || (br = f);
        }
    }
    if ((o || document.addEventListener("touchstart", Vi, n), s ? i || document.addEventListener("mousedown", Hi, n) : document.addEventListener("mouseover", Bi, n), i && document.addEventListener("mousedown", Ui, n), u)) {
        let d = window.requestIdleCallback;
        d ||
            (d = (f) => {
                f();
            }),
            d(
                function () {
                    let y = new IntersectionObserver((m) => {
                        m.forEach((v) => {
                            if (v.isIntersecting) {
                                let _ = v.target;
                                y.unobserve(_), se(_.href);
                            }
                        });
                    });
                    document.querySelectorAll("a").forEach((m) => {
                        oe(m) && y.observe(m);
                    });
                },
                { timeout: 1500 }
            );
    }
}
function Vi(e) {
    Re = performance.now();
    let t = e.target.closest("a");
    oe(t) && se(t.href, "high");
}
function Bi(e) {
    if (performance.now() - Re < wr || !("closest" in e.target)) return;
    let t = e.target.closest("a");
    oe(t) &&
        (t.addEventListener("mouseout", Ki, { passive: !0 }),
        (Ct = setTimeout(() => {
            se(t.href, "high"), (Ct = void 0);
        }, br)));
}
function Hi(e) {
    let t = e.target.closest("a");
    oe(t) && se(t.href, "high");
}
function Ki(e) {
    (e.relatedTarget && e.target.closest("a") == e.relatedTarget.closest("a")) || (Ct && (clearTimeout(Ct), (Ct = void 0)));
}
function Ui(e) {
    if (performance.now() - Re < wr) return;
    let t = e.target.closest("a");
    if (e.which > 1 || e.metaKey || e.ctrlKey || !t) return;
    t.addEventListener(
        "click",
        function (i) {
            i.detail != 1337 && i.preventDefault();
        },
        { capture: !0, passive: !1, once: !0 }
    );
    let r = new MouseEvent("click", { view: window, bubbles: !0, cancelable: !1, detail: 1337 });
    t.dispatchEvent(r);
}
function oe(e) {
    if (
        !(!e || !e.href) &&
        !(yr && !("instant" in e.dataset)) &&
        !(e.origin != location.origin && (!(gr || "instant" in e.dataset) || !ne)) &&
        ["http:", "https:"].includes(e.protocol) &&
        !(e.protocol == "http:" && location.protocol == "https:") &&
        !(!vr && e.search && !("instant" in e.dataset)) &&
        !(e.hash && e.pathname + e.search == location.pathname + location.search) &&
        !("noInstant" in e.dataset)
    )
        return !0;
}
function se(e, t = "auto") {
    if (mr.has(e)) return;
    let r = document.createElement("link");
    (r.rel = "prefetch"), (r.href = e), (r.fetchPriority = t), (r.as = "document"), document.head.appendChild(r), mr.add(e);
}
var ke = {};
zi(ke, { createFocusTrap: () => gn });
var xr = [
        "input:not([inert])",
        "select:not([inert])",
        "textarea:not([inert])",
        "a[href]:not([inert])",
        "button:not([inert])",
        "[tabindex]:not(slot):not([inert])",
        "audio[controls]:not([inert])",
        "video[controls]:not([inert])",
        '[contenteditable]:not([contenteditable="false"]):not([inert])',
        "details>summary:first-of-type:not([inert])",
        "details:not([inert])",
    ],
    ae = xr.join(","),
    Sr = typeof Element > "u",
    St = Sr ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
    le =
        !Sr && Element.prototype.getRootNode
            ? function (e) {
                  var t;
                  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
              }
            : function (e) {
                  return e?.ownerDocument;
              },
    ce = function e(t, r) {
        var i;
        r === void 0 && (r = !0);
        var n = t == null || (i = t.getAttribute) === null || i === void 0 ? void 0 : i.call(t, "inert"),
            s = n === "" || n === "true",
            o = s || (r && t && e(t.parentNode));
        return o;
    },
    qi = function (t) {
        var r,
            i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "contenteditable");
        return i === "" || i === "true";
    },
    Or = function (t, r, i) {
        if (ce(t)) return [];
        var n = Array.prototype.slice.apply(t.querySelectorAll(ae));
        return r && St.call(t, ae) && n.unshift(t), (n = n.filter(i)), n;
    },
    Tr = function e(t, r, i) {
        for (var n = [], s = Array.from(t); s.length; ) {
            var o = s.shift();
            if (!ce(o, !1))
                if (o.tagName === "SLOT") {
                    var u = o.assignedElements(),
                        d = u.length ? u : o.children,
                        f = e(d, !0, i);
                    i.flatten ? n.push.apply(n, f) : n.push({ scopeParent: o, candidates: f });
                } else {
                    var y = St.call(o, ae);
                    y && i.filter(o) && (r || !t.includes(o)) && n.push(o);
                    var m = o.shadowRoot || (typeof i.getShadowRoot == "function" && i.getShadowRoot(o)),
                        v = !ce(m, !1) && (!i.shadowRootFilter || i.shadowRootFilter(o));
                    if (m && v) {
                        var _ = e(m === !0 ? o.children : m.children, !0, i);
                        i.flatten ? n.push.apply(n, _) : n.push({ scopeParent: o, candidates: _ });
                    } else s.unshift.apply(s, o.children);
                }
        }
        return n;
    },
    Ar = function (t) {
        return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
    },
    vt = function (t) {
        if (!t) throw new Error("No node provided");
        return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || qi(t)) && !Ar(t) ? 0 : t.tabIndex;
    },
    Gi = function (t, r) {
        var i = vt(t);
        return i < 0 && r && !Ar(t) ? 0 : i;
    },
    Zi = function (t, r) {
        return t.tabIndex === r.tabIndex ? t.documentOrder - r.documentOrder : t.tabIndex - r.tabIndex;
    },
    Ir = function (t) {
        return t.tagName === "INPUT";
    },
    Xi = function (t) {
        return Ir(t) && t.type === "hidden";
    },
    Yi = function (t) {
        var r =
            t.tagName === "DETAILS" &&
            Array.prototype.slice.apply(t.children).some(function (i) {
                return i.tagName === "SUMMARY";
            });
        return r;
    },
    Qi = function (t, r) {
        for (var i = 0; i < t.length; i++) if (t[i].checked && t[i].form === r) return t[i];
    },
    Ji = function (t) {
        if (!t.name) return !0;
        var r = t.form || le(t),
            i = function (u) {
                return r.querySelectorAll('input[type="radio"][name="' + u + '"]');
            },
            n;
        if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function") n = i(window.CSS.escape(t.name));
        else
            try {
                n = i(t.name);
            } catch (o) {
                return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
            }
        var s = Qi(n, t.form);
        return !s || s === t;
    },
    tn = function (t) {
        return Ir(t) && t.type === "radio";
    },
    en = function (t) {
        return tn(t) && !Ji(t);
    },
    rn = function (t) {
        var r,
            i = t && le(t),
            n = (r = i) === null || r === void 0 ? void 0 : r.host,
            s = !1;
        if (i && i !== t) {
            var o, u, d;
            for (s = !!(((o = n) !== null && o !== void 0 && (u = o.ownerDocument) !== null && u !== void 0 && u.contains(n)) || (t != null && (d = t.ownerDocument) !== null && d !== void 0 && d.contains(t))); !s && n; ) {
                var f, y, m;
                (i = le(n)), (n = (f = i) === null || f === void 0 ? void 0 : f.host), (s = !!((y = n) !== null && y !== void 0 && (m = y.ownerDocument) !== null && m !== void 0 && m.contains(n)));
            }
        }
        return s;
    },
    Er = function (t) {
        var r = t.getBoundingClientRect(),
            i = r.width,
            n = r.height;
        return i === 0 && n === 0;
    },
    nn = function (t, r) {
        var i = r.displayCheck,
            n = r.getShadowRoot;
        if (getComputedStyle(t).visibility === "hidden") return !0;
        var s = St.call(t, "details>summary:first-of-type"),
            o = s ? t.parentElement : t;
        if (St.call(o, "details:not([open]) *")) return !0;
        if (!i || i === "full" || i === "legacy-full") {
            if (typeof n == "function") {
                for (var u = t; t; ) {
                    var d = t.parentElement,
                        f = le(t);
                    if (d && !d.shadowRoot && n(d) === !0) return Er(t);
                    t.assignedSlot ? (t = t.assignedSlot) : !d && f !== t.ownerDocument ? (t = f.host) : (t = d);
                }
                t = u;
            }
            if (rn(t)) return !t.getClientRects().length;
            if (i !== "legacy-full") return !0;
        } else if (i === "non-zero-area") return Er(t);
        return !1;
    },
    on = function (t) {
        if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
            for (var r = t.parentElement; r; ) {
                if (r.tagName === "FIELDSET" && r.disabled) {
                    for (var i = 0; i < r.children.length; i++) {
                        var n = r.children.item(i);
                        if (n.tagName === "LEGEND") return St.call(r, "fieldset[disabled] *") ? !0 : !n.contains(t);
                    }
                    return !0;
                }
                r = r.parentElement;
            }
        return !1;
    },
    ue = function (t, r) {
        return !(r.disabled || ce(r) || Xi(r) || nn(r, t) || Yi(r) || on(r));
    },
    Me = function (t, r) {
        return !(en(r) || vt(r) < 0 || !ue(t, r));
    },
    sn = function (t) {
        var r = parseInt(t.getAttribute("tabindex"), 10);
        return !!(isNaN(r) || r >= 0);
    },
    an = function e(t) {
        var r = [],
            i = [];
        return (
            t.forEach(function (n, s) {
                var o = !!n.scopeParent,
                    u = o ? n.scopeParent : n,
                    d = Gi(u, o),
                    f = o ? e(n.candidates) : u;
                d === 0 ? (o ? r.push.apply(r, f) : r.push(u)) : i.push({ documentOrder: s, tabIndex: d, item: n, isScope: o, content: f });
            }),
            i
                .sort(Zi)
                .reduce(function (n, s) {
                    return s.isScope ? n.push.apply(n, s.content) : n.push(s.content), n;
                }, [])
                .concat(r)
        );
    },
    _r = function (t, r) {
        r = r || {};
        var i;
        return r.getShadowRoot ? (i = Tr([t], r.includeContainer, { filter: Me.bind(null, r), flatten: !1, getShadowRoot: r.getShadowRoot, shadowRootFilter: sn })) : (i = Or(t, r.includeContainer, Me.bind(null, r))), an(i);
    },
    Nr = function (t, r) {
        r = r || {};
        var i;
        return r.getShadowRoot ? (i = Tr([t], r.includeContainer, { filter: ue.bind(null, r), flatten: !0, getShadowRoot: r.getShadowRoot })) : (i = Or(t, r.includeContainer, ue.bind(null, r))), i;
    },
    Ot = function (t, r) {
        if (((r = r || {}), !t)) throw new Error("No node provided");
        return St.call(t, ae) === !1 ? !1 : Me(r, t);
    },
    ln = xr.concat("iframe").join(","),
    fe = function (t, r) {
        if (((r = r || {}), !t)) throw new Error("No node provided");
        return St.call(t, ln) === !1 ? !1 : ue(r, t);
    };
function Dr(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        t &&
            (i = i.filter(function (n) {
                return Object.getOwnPropertyDescriptor(e, n).enumerable;
            })),
            r.push.apply(r, i);
    }
    return r;
}
function Pr(e) {
    for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t] != null ? arguments[t] : {};
        t % 2
            ? Dr(Object(r), !0).forEach(function (i) {
                  cn(e, i, r[i]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
            : Dr(Object(r)).forEach(function (i) {
                  Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(r, i));
              });
    }
    return e;
}
function cn(e, t, r) {
    return (t = fn(t)), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = r), e;
}
function un(e, t) {
    if (typeof e != "object" || e === null) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
        var i = r.call(e, t || "default");
        if (typeof i != "object") return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
}
function fn(e) {
    var t = un(e, "string");
    return typeof t == "symbol" ? t : String(t);
}
var Fr = {
        activateTrap: function (t, r) {
            if (t.length > 0) {
                var i = t[t.length - 1];
                i !== r && i.pause();
            }
            var n = t.indexOf(r);
            n === -1 || t.splice(n, 1), t.push(r);
        },
        deactivateTrap: function (t, r) {
            var i = t.indexOf(r);
            i !== -1 && t.splice(i, 1), t.length > 0 && t[t.length - 1].unpause();
        },
    },
    dn = function (t) {
        return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
    },
    hn = function (t) {
        return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
    },
    Mt = function (t) {
        return t?.key === "Tab" || t?.keyCode === 9;
    },
    pn = function (t) {
        return Mt(t) && !t.shiftKey;
    },
    mn = function (t) {
        return Mt(t) && t.shiftKey;
    },
    Lr = function (t) {
        return setTimeout(t, 0);
    },
    Cr = function (t, r) {
        var i = -1;
        return (
            t.every(function (n, s) {
                return r(n) ? ((i = s), !1) : !0;
            }),
            i
        );
    },
    Rt = function (t) {
        for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++) i[n - 1] = arguments[n];
        return typeof t == "function" ? t.apply(void 0, i) : t;
    },
    de = function (t) {
        return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
    },
    vn = [],
    gn = function (t, r) {
        var i = r?.document || document,
            n = r?.trapStack || vn,
            s = Pr({ returnFocusOnDeactivate: !0, escapeDeactivates: !0, delayInitialFocus: !0, isKeyForward: pn, isKeyBackward: mn }, r),
            o = { containers: [], containerGroups: [], tabbableGroups: [], nodeFocusedBeforeActivation: null, mostRecentlyFocusedNode: null, active: !1, paused: !1, delayInitialFocusTimer: void 0, recentNavEvent: void 0 },
            u,
            d = function (a, l, g) {
                return a && a[l] !== void 0 ? a[l] : s[g || l];
            },
            f = function (a, l) {
                var g = typeof l?.composedPath == "function" ? l.composedPath() : void 0;
                return o.containerGroups.findIndex(function (x) {
                    var I = x.container,
                        L = x.tabbableNodes;
                    return (
                        I.contains(a) ||
                        g?.includes(I) ||
                        L.find(function (M) {
                            return M === a;
                        })
                    );
                });
            },
            y = function (a) {
                var l = s[a];
                if (typeof l == "function") {
                    for (var g = arguments.length, x = new Array(g > 1 ? g - 1 : 0), I = 1; I < g; I++) x[I - 1] = arguments[I];
                    l = l.apply(void 0, x);
                }
                if ((l === !0 && (l = void 0), !l)) {
                    if (l === void 0 || l === !1) return l;
                    throw new Error("`".concat(a, "` was specified but was not a node, or did not return a node"));
                }
                var L = l;
                if (typeof l == "string" && ((L = i.querySelector(l)), !L)) throw new Error("`".concat(a, "` as selector refers to no known node"));
                return L;
            },
            m = function () {
                var a = y("initialFocus");
                if (a === !1) return !1;
                if (a === void 0 || !fe(a, s.tabbableOptions))
                    if (f(i.activeElement) >= 0) a = i.activeElement;
                    else {
                        var l = o.tabbableGroups[0],
                            g = l && l.firstTabbableNode;
                        a = g || y("fallbackFocus");
                    }
                if (!a) throw new Error("Your focus-trap needs to have at least one focusable element");
                return a;
            },
            v = function () {
                if (
                    ((o.containerGroups = o.containers.map(function (a) {
                        var l = _r(a, s.tabbableOptions),
                            g = Nr(a, s.tabbableOptions),
                            x = l.length > 0 ? l[0] : void 0,
                            I = l.length > 0 ? l[l.length - 1] : void 0,
                            L = g.find(function (H) {
                                return Ot(H);
                            }),
                            M = g
                                .slice()
                                .reverse()
                                .find(function (H) {
                                    return Ot(H);
                                }),
                            W = !!l.find(function (H) {
                                return vt(H) > 0;
                            });
                        return {
                            container: a,
                            tabbableNodes: l,
                            focusableNodes: g,
                            posTabIndexesFound: W,
                            firstTabbableNode: x,
                            lastTabbableNode: I,
                            firstDomTabbableNode: L,
                            lastDomTabbableNode: M,
                            nextTabbableNode: function (nt) {
                                var ht = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0,
                                    rt = l.indexOf(nt);
                                return rt < 0
                                    ? ht
                                        ? g.slice(g.indexOf(nt) + 1).find(function (st) {
                                              return Ot(st);
                                          })
                                        : g
                                              .slice(0, g.indexOf(nt))
                                              .reverse()
                                              .find(function (st) {
                                                  return Ot(st);
                                              })
                                    : l[rt + (ht ? 1 : -1)];
                            },
                        };
                    })),
                    (o.tabbableGroups = o.containerGroups.filter(function (a) {
                        return a.tabbableNodes.length > 0;
                    })),
                    o.tabbableGroups.length <= 0 && !y("fallbackFocus"))
                )
                    throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
                if (
                    o.containerGroups.find(function (a) {
                        return a.posTabIndexesFound;
                    }) &&
                    o.containerGroups.length > 1
                )
                    throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
            },
            _ = function S(a) {
                var l = a.activeElement;
                if (l) return l.shadowRoot && l.shadowRoot.activeElement !== null ? S(l.shadowRoot) : l;
            },
            z = function S(a) {
                if (a !== !1 && a !== _(document)) {
                    if (!a || !a.focus) {
                        S(m());
                        return;
                    }
                    a.focus({ preventScroll: !!s.preventScroll }), (o.mostRecentlyFocusedNode = a), dn(a) && a.select();
                }
            },
            j = function (a) {
                var l = y("setReturnFocus", a);
                return l || (l === !1 ? !1 : a);
            },
            R = function (a) {
                var l = a.target,
                    g = a.event,
                    x = a.isBackward,
                    I = x === void 0 ? !1 : x;
                (l = l || de(g)), v();
                var L = null;
                if (o.tabbableGroups.length > 0) {
                    var M = f(l, g),
                        W = M >= 0 ? o.containerGroups[M] : void 0;
                    if (M < 0) I ? (L = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode) : (L = o.tabbableGroups[0].firstTabbableNode);
                    else if (I) {
                        var H = Cr(o.tabbableGroups, function (ct) {
                            var Nt = ct.firstTabbableNode;
                            return l === Nt;
                        });
                        if ((H < 0 && (W.container === l || (fe(l, s.tabbableOptions) && !Ot(l, s.tabbableOptions) && !W.nextTabbableNode(l, !1))) && (H = M), H >= 0)) {
                            var nt = H === 0 ? o.tabbableGroups.length - 1 : H - 1,
                                ht = o.tabbableGroups[nt];
                            L = vt(l) >= 0 ? ht.lastTabbableNode : ht.lastDomTabbableNode;
                        } else Mt(g) || (L = W.nextTabbableNode(l, !1));
                    } else {
                        var rt = Cr(o.tabbableGroups, function (ct) {
                            var Nt = ct.lastTabbableNode;
                            return l === Nt;
                        });
                        if ((rt < 0 && (W.container === l || (fe(l, s.tabbableOptions) && !Ot(l, s.tabbableOptions) && !W.nextTabbableNode(l))) && (rt = M), rt >= 0)) {
                            var st = rt === o.tabbableGroups.length - 1 ? 0 : rt + 1,
                                Lt = o.tabbableGroups[st];
                            L = vt(l) >= 0 ? Lt.firstTabbableNode : Lt.firstDomTabbableNode;
                        } else Mt(g) || (L = W.nextTabbableNode(l));
                    }
                } else L = y("fallbackFocus");
                return L;
            },
            B = function (a) {
                var l = de(a);
                if (!(f(l, a) >= 0)) {
                    if (Rt(s.clickOutsideDeactivates, a)) {
                        u.deactivate({ returnFocus: s.returnFocusOnDeactivate });
                        return;
                    }
                    Rt(s.allowOutsideClick, a) || a.preventDefault();
                }
            },
            P = function (a) {
                var l = de(a),
                    g = f(l, a) >= 0;
                if (g || l instanceof Document) g && (o.mostRecentlyFocusedNode = l);
                else {
                    a.stopImmediatePropagation();
                    var x,
                        I = !0;
                    if (o.mostRecentlyFocusedNode)
                        if (vt(o.mostRecentlyFocusedNode) > 0) {
                            var L = f(o.mostRecentlyFocusedNode),
                                M = o.containerGroups[L].tabbableNodes;
                            if (M.length > 0) {
                                var W = M.findIndex(function (H) {
                                    return H === o.mostRecentlyFocusedNode;
                                });
                                W >= 0 && (s.isKeyForward(o.recentNavEvent) ? W + 1 < M.length && ((x = M[W + 1]), (I = !1)) : W - 1 >= 0 && ((x = M[W - 1]), (I = !1)));
                            }
                        } else
                            o.containerGroups.some(function (H) {
                                return H.tabbableNodes.some(function (nt) {
                                    return vt(nt) > 0;
                                });
                            }) || (I = !1);
                    else I = !1;
                    I && (x = R({ target: o.mostRecentlyFocusedNode, isBackward: s.isKeyBackward(o.recentNavEvent) })), z(x || o.mostRecentlyFocusedNode || m());
                }
                o.recentNavEvent = void 0;
            },
            F = function (a) {
                var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                o.recentNavEvent = a;
                var g = R({ event: a, isBackward: l });
                g && (Mt(a) && a.preventDefault(), z(g));
            },
            C = function (a) {
                if (hn(a) && Rt(s.escapeDeactivates, a) !== !1) {
                    a.preventDefault(), u.deactivate();
                    return;
                }
                (s.isKeyForward(a) || s.isKeyBackward(a)) && F(a, s.isKeyBackward(a));
            },
            Y = function (a) {
                var l = de(a);
                f(l, a) >= 0 || Rt(s.clickOutsideDeactivates, a) || Rt(s.allowOutsideClick, a) || (a.preventDefault(), a.stopImmediatePropagation());
            },
            k = function () {
                if (o.active)
                    return (
                        Fr.activateTrap(n, u),
                        (o.delayInitialFocusTimer = s.delayInitialFocus
                            ? Lr(function () {
                                  z(m());
                              })
                            : z(m())),
                        i.addEventListener("focusin", P, !0),
                        i.addEventListener("mousedown", B, { capture: !0, passive: !1 }),
                        i.addEventListener("touchstart", B, { capture: !0, passive: !1 }),
                        i.addEventListener("click", Y, { capture: !0, passive: !1 }),
                        i.addEventListener("keydown", C, { capture: !0, passive: !1 }),
                        u
                    );
            },
            tt = function () {
                if (o.active)
                    return i.removeEventListener("focusin", P, !0), i.removeEventListener("mousedown", B, !0), i.removeEventListener("touchstart", B, !0), i.removeEventListener("click", Y, !0), i.removeEventListener("keydown", C, !0), u;
            },
            T = function (a) {
                var l = a.some(function (g) {
                    var x = Array.from(g.removedNodes);
                    return x.some(function (I) {
                        return I === o.mostRecentlyFocusedNode;
                    });
                });
                l && z(m());
            },
            et = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(T) : void 0,
            A = function () {
                et &&
                    (et.disconnect(),
                    o.active &&
                        !o.paused &&
                        o.containers.map(function (a) {
                            et.observe(a, { subtree: !0, childList: !0 });
                        }));
            };
        return (
            (u = {
                get active() {
                    return o.active;
                },
                get paused() {
                    return o.paused;
                },
                activate: function (a) {
                    if (o.active) return this;
                    var l = d(a, "onActivate"),
                        g = d(a, "onPostActivate"),
                        x = d(a, "checkCanFocusTrap");
                    x || v(), (o.active = !0), (o.paused = !1), (o.nodeFocusedBeforeActivation = i.activeElement), l?.();
                    var I = function () {
                        x && v(), k(), A(), g?.();
                    };
                    return x ? (x(o.containers.concat()).then(I, I), this) : (I(), this);
                },
                deactivate: function (a) {
                    if (!o.active) return this;
                    var l = Pr({ onDeactivate: s.onDeactivate, onPostDeactivate: s.onPostDeactivate, checkCanReturnFocus: s.checkCanReturnFocus }, a);
                    clearTimeout(o.delayInitialFocusTimer), (o.delayInitialFocusTimer = void 0), tt(), (o.active = !1), (o.paused = !1), A(), Fr.deactivateTrap(n, u);
                    var g = d(l, "onDeactivate"),
                        x = d(l, "onPostDeactivate"),
                        I = d(l, "checkCanReturnFocus"),
                        L = d(l, "returnFocus", "returnFocusOnDeactivate");
                    g?.();
                    var M = function () {
                        Lr(function () {
                            L && z(j(o.nodeFocusedBeforeActivation)), x?.();
                        });
                    };
                    return L && I ? (I(j(o.nodeFocusedBeforeActivation)).then(M, M), this) : (M(), this);
                },
                pause: function (a) {
                    if (o.paused || !o.active) return this;
                    var l = d(a, "onPause"),
                        g = d(a, "onPostPause");
                    return (o.paused = !0), l?.(), tt(), A(), g?.(), this;
                },
                unpause: function (a) {
                    if (!o.paused || !o.active) return this;
                    var l = d(a, "onUnpause"),
                        g = d(a, "onPostUnpause");
                    return (o.paused = !1), l?.(), v(), k(), A(), g?.(), this;
                },
                updateContainerElements: function (a) {
                    var l = [].concat(a).filter(Boolean);
                    return (
                        (o.containers = l.map(function (g) {
                            return typeof g == "string" ? i.querySelector(g) : g;
                        })),
                        o.active && v(),
                        A(),
                        this
                    );
                },
            }),
            u.updateContainerElements(t),
            u
        );
    };
var fo = $i(Rr());
function ze(e, t) {
    e.indexOf(t) === -1 && e.push(t);
}
function je(e, t) {
    let r = e.indexOf(t);
    r > -1 && e.splice(r, 1);
}
var kt = (e, t, r) => Math.min(Math.max(r, e), t);
var V = { duration: 0.3, delay: 0, endDelay: 0, repeat: 0, easing: "ease" };
var X = (e) => typeof e == "number";
var lt = (e) => Array.isArray(e) && !X(e[0]);
var Mr = (e, t, r) => {
    let i = t - e;
    return ((((r - e) % i) + i) % i) + e;
};
function zt(e, t) {
    return lt(e) ? e[Mr(0, e.length, t)] : e;
}
var Tt = (e, t, r) => -r * e + r * t + e;
var jt = () => {},
    G = (e) => e;
var ot = (e, t, r) => (t - e === 0 ? 1 : (r - e) / (t - e));
function Pt(e, t) {
    let r = e[e.length - 1];
    for (let i = 1; i <= t; i++) {
        let n = ot(0, t, i);
        e.push(Tt(r, 1, n));
    }
}
function At(e) {
    let t = [0];
    return Pt(t, e - 1), t;
}
function $t(e, t = At(e.length), r = G) {
    let i = e.length,
        n = i - t.length;
    return (
        n > 0 && Pt(t, n),
        (s) => {
            let o = 0;
            for (; o < i - 2 && !(s < t[o + 1]); o++);
            let u = kt(0, 1, ot(t[o], t[o + 1], s));
            return (u = zt(r, o)(u)), Tt(e[o], e[o + 1], u);
        }
    );
}
var Wt = (e) => Array.isArray(e) && X(e[0]);
var gt = (e) => typeof e == "object" && !!e.createAnimation;
var q = (e) => typeof e == "function";
var ut = (e) => typeof e == "string";
var yt = { ms: (e) => e * 1e3, s: (e) => e / 1e3 };
function $e(e, t) {
    return t ? e * (1e3 / t) : 0;
}
var kr = (e, t, r) => (((1 - 3 * r + 3 * t) * e + (3 * r - 6 * t)) * e + 3 * t) * e,
    yn = 1e-7,
    bn = 12;
function wn(e, t, r, i, n) {
    let s,
        o,
        u = 0;
    do (o = t + (r - t) / 2), (s = kr(o, i, n) - e), s > 0 ? (r = o) : (t = o);
    while (Math.abs(s) > yn && ++u < bn);
    return o;
}
function It(e, t, r, i) {
    if (e === t && r === i) return G;
    let n = (s) => wn(s, 0, 1, e, r);
    return (s) => (s === 0 || s === 1 ? s : kr(n(s), t, i));
}
var We = (e, t = "end") => (r) => {
    r = t === "end" ? Math.min(r, 0.999) : Math.max(r, 0.001);
    let i = r * e,
        n = t === "end" ? Math.floor(i) : Math.ceil(i);
    return kt(0, 1, n / e);
};
var zr = { ease: It(0.25, 0.1, 0.25, 1), "ease-in": It(0.42, 0, 1, 1), "ease-in-out": It(0.42, 0, 0.58, 1), "ease-out": It(0, 0, 0.58, 1) },
    En = /\((.*?)\)/;
function Ft(e) {
    if (q(e)) return e;
    if (Wt(e)) return It(...e);
    if (zr[e]) return zr[e];
    if (e.startsWith("steps")) {
        let t = En.exec(e);
        if (t) {
            let r = t[1].split(",");
            return We(parseFloat(r[0]), r[1].trim());
        }
    }
    return G;
}
var ft = class {
    constructor(t, r = [0, 1], { easing: i, duration: n = V.duration, delay: s = V.delay, endDelay: o = V.endDelay, repeat: u = V.repeat, offset: d, direction: f = "normal" } = {}) {
        if (
            ((this.startTime = null),
            (this.rate = 1),
            (this.t = 0),
            (this.cancelTimestamp = null),
            (this.easing = G),
            (this.duration = 0),
            (this.totalDuration = 0),
            (this.repeat = 0),
            (this.playState = "idle"),
            (this.finished = new Promise((m, v) => {
                (this.resolve = m), (this.reject = v);
            })),
            (i = i || V.easing),
            gt(i))
        ) {
            let m = i.createAnimation(r);
            (i = m.easing), (r = m.keyframes || r), (n = m.duration || n);
        }
        (this.repeat = u), (this.easing = lt(i) ? G : Ft(i)), this.updateDuration(n);
        let y = $t(r, d, lt(i) ? i.map(Ft) : G);
        (this.tick = (m) => {
            var v;
            s = s;
            let _ = 0;
            this.pauseTime !== void 0 ? (_ = this.pauseTime) : (_ = (m - this.startTime) * this.rate),
                (this.t = _),
                (_ /= 1e3),
                (_ = Math.max(_ - s, 0)),
                this.playState === "finished" && this.pauseTime === void 0 && (_ = this.totalDuration);
            let z = _ / this.duration,
                j = Math.floor(z),
                R = z % 1;
            !R && z >= 1 && (R = 1), R === 1 && j--;
            let B = j % 2;
            (f === "reverse" || (f === "alternate" && B) || (f === "alternate-reverse" && !B)) && (R = 1 - R);
            let P = _ >= this.totalDuration ? 1 : Math.min(R, 1),
                F = y(this.easing(P));
            t(F),
                this.pauseTime === void 0 && (this.playState === "finished" || _ >= this.totalDuration + o)
                    ? ((this.playState = "finished"), (v = this.resolve) === null || v === void 0 || v.call(this, F))
                    : this.playState !== "idle" && (this.frameRequestId = requestAnimationFrame(this.tick));
        }),
            this.play();
    }
    play() {
        let t = performance.now();
        (this.playState = "running"),
            this.pauseTime !== void 0 ? (this.startTime = t - this.pauseTime) : this.startTime || (this.startTime = t),
            (this.cancelTimestamp = this.startTime),
            (this.pauseTime = void 0),
            (this.frameRequestId = requestAnimationFrame(this.tick));
    }
    pause() {
        (this.playState = "paused"), (this.pauseTime = this.t);
    }
    finish() {
        (this.playState = "finished"), this.tick(0);
    }
    stop() {
        var t;
        (this.playState = "idle"), this.frameRequestId !== void 0 && cancelAnimationFrame(this.frameRequestId), (t = this.reject) === null || t === void 0 || t.call(this, !1);
    }
    cancel() {
        this.stop(), this.tick(this.cancelTimestamp);
    }
    reverse() {
        this.rate *= -1;
    }
    commitStyles() {}
    updateDuration(t) {
        (this.duration = t), (this.totalDuration = t * (this.repeat + 1));
    }
    get currentTime() {
        return this.t;
    }
    set currentTime(t) {
        this.pauseTime !== void 0 || this.rate === 0 ? (this.pauseTime = t) : (this.startTime = performance.now() - t / this.rate);
    }
    get playbackRate() {
        return this.rate;
    }
    set playbackRate(t) {
        this.rate = t;
    }
};
var Vt = function () {};
var Bt = class {
    setAnimation(t) {
        (this.animation = t), t?.finished.then(() => this.clearAnimation()).catch(() => {});
    }
    clearAnimation() {
        this.animation = this.generator = void 0;
    }
};
var Ve = new WeakMap();
function he(e) {
    return Ve.has(e) || Ve.set(e, { transforms: [], values: new Map() }), Ve.get(e);
}
function jr(e, t) {
    return e.has(t) || e.set(t, new Bt()), e.get(t);
}
var xn = ["", "X", "Y", "Z"],
    Sn = ["translate", "scale", "rotate", "skew"],
    Ht = { x: "translateX", y: "translateY", z: "translateZ" },
    $r = { syntax: "<angle>", initialValue: "0deg", toDefaultUnit: (e) => e + "deg" },
    On = { translate: { syntax: "<length-percentage>", initialValue: "0px", toDefaultUnit: (e) => e + "px" }, rotate: $r, scale: { syntax: "<number>", initialValue: 1, toDefaultUnit: G }, skew: $r },
    bt = new Map(),
    me = (e) => `--motion-${e}`,
    pe = ["x", "y", "z"];
Sn.forEach((e) => {
    xn.forEach((t) => {
        pe.push(e + t), bt.set(me(e + t), On[e]);
    });
});
var Tn = (e, t) => pe.indexOf(e) - pe.indexOf(t),
    An = new Set(pe),
    ve = (e) => An.has(e),
    Wr = (e, t) => {
        Ht[t] && (t = Ht[t]);
        let { transforms: r } = he(e);
        ze(r, t), (e.style.transform = In(r));
    },
    In = (e) => e.sort(Tn).reduce(_n, "").trim(),
    _n = (e, t) => `${e} ${t}(var(${me(t)}))`;
var Kt = (e) => e.startsWith("--"),
    Vr = new Set();
function Br(e) {
    if (!Vr.has(e)) {
        Vr.add(e);
        try {
            let { syntax: t, initialValue: r } = bt.has(e) ? bt.get(e) : {};
            CSS.registerProperty({ name: e, inherits: !1, syntax: t, initialValue: r });
        } catch {}
    }
}
var Be = (e, t) => document.createElement("div").animate(e, t),
    Hr = {
        cssRegisterProperty: () => typeof CSS < "u" && Object.hasOwnProperty.call(CSS, "registerProperty"),
        waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
        partialKeyframes: () => {
            try {
                Be({ opacity: [1] });
            } catch {
                return !1;
            }
            return !0;
        },
        finished: () => !!Be({ opacity: [0, 1] }, { duration: 0.001 }).finished,
        linearEasing: () => {
            try {
                Be({ opacity: 0 }, { easing: "linear(0, 1)" });
            } catch {
                return !1;
            }
            return !0;
        },
    },
    He = {},
    wt = {};
for (let e in Hr) wt[e] = () => (He[e] === void 0 && (He[e] = Hr[e]()), He[e]);
var Nn = 0.015,
    Dn = (e, t) => {
        let r = "",
            i = Math.round(t / Nn);
        for (let n = 0; n < i; n++) r += e(ot(0, i - 1, n)) + ", ";
        return r.substring(0, r.length - 2);
    },
    Ke = (e, t) => (q(e) ? (wt.linearEasing() ? `linear(${Dn(e, t)})` : V.easing) : Wt(e) ? Pn(e) : e),
    Pn = ([e, t, r, i]) => `cubic-bezier(${e}, ${t}, ${r}, ${i})`;
function Kr(e, t) {
    for (let r = 0; r < e.length; r++) e[r] === null && (e[r] = r ? e[r - 1] : t());
    return e;
}
var ge = (e) => (Array.isArray(e) ? e : [e]);
function Ut(e) {
    return Ht[e] && (e = Ht[e]), ve(e) ? me(e) : e;
}
var qt = {
    get: (e, t) => {
        t = Ut(t);
        let r = Kt(t) ? e.style.getPropertyValue(t) : getComputedStyle(e)[t];
        if (!r && r !== 0) {
            let i = bt.get(t);
            i && (r = i.initialValue);
        }
        return r;
    },
    set: (e, t, r) => {
        (t = Ut(t)), Kt(t) ? e.style.setProperty(t, r) : (e.style[t] = r);
    },
};
function ye(e, t = !0) {
    if (!(!e || e.playState === "finished"))
        try {
            e.stop ? e.stop() : (t && e.commitStyles(), e.cancel());
        } catch {}
}
function Ur(e, t) {
    var r;
    let i = t?.toDefaultUnit || G,
        n = e[e.length - 1];
    if (ut(n)) {
        let s = ((r = n.match(/(-?[\d.]+)([a-z%]*)/)) === null || r === void 0 ? void 0 : r[2]) || "";
        s && (i = (o) => o + s);
    }
    return i;
}
function Fn() {
    return window.__MOTION_DEV_TOOLS_RECORD;
}
function be(e, t, r, i = {}, n) {
    let s = Fn(),
        o = i.record !== !1 && s,
        u,
        { duration: d = V.duration, delay: f = V.delay, endDelay: y = V.endDelay, repeat: m = V.repeat, easing: v = V.easing, persist: _ = !1, direction: z, offset: j, allowWebkitAcceleration: R = !1 } = i,
        B = he(e),
        P = ve(t),
        F = wt.waapi();
    P && Wr(e, t);
    let C = Ut(t),
        Y = jr(B.values, C),
        k = bt.get(C);
    return (
        ye(Y.animation, !(gt(v) && Y.generator) && i.record !== !1),
        () => {
            let tt = () => {
                    var A, S;
                    return (S = (A = qt.get(e, C)) !== null && A !== void 0 ? A : k?.initialValue) !== null && S !== void 0 ? S : 0;
                },
                T = Kr(ge(r), tt),
                et = Ur(T, k);
            if (gt(v)) {
                let A = v.createAnimation(T, t !== "opacity", tt, C, Y);
                (v = A.easing), (T = A.keyframes || T), (d = A.duration || d);
            }
            if ((Kt(C) && (wt.cssRegisterProperty() ? Br(C) : (F = !1)), P && !wt.linearEasing() && (q(v) || (lt(v) && v.some(q))) && (F = !1), F)) {
                k && (T = T.map((a) => (X(a) ? k.toDefaultUnit(a) : a))), T.length === 1 && (!wt.partialKeyframes() || o) && T.unshift(tt());
                let A = { delay: yt.ms(f), duration: yt.ms(d), endDelay: yt.ms(y), easing: lt(v) ? void 0 : Ke(v, d), direction: z, iterations: m + 1, fill: "both" };
                (u = e.animate({ [C]: T, offset: j, easing: lt(v) ? v.map((a) => Ke(a, d)) : void 0 }, A)),
                    u.finished ||
                        (u.finished = new Promise((a, l) => {
                            (u.onfinish = a), (u.oncancel = l);
                        }));
                let S = T[T.length - 1];
                u.finished
                    .then(() => {
                        _ || (qt.set(e, C, S), u.cancel());
                    })
                    .catch(jt),
                    R || (u.playbackRate = 1.000001);
            } else if (n && P)
                (T = T.map((A) => (typeof A == "string" ? parseFloat(A) : A))),
                    T.length === 1 && T.unshift(parseFloat(tt())),
                    (u = new n(
                        (A) => {
                            qt.set(e, C, et ? et(A) : A);
                        },
                        T,
                        Object.assign(Object.assign({}, i), { duration: d, easing: v })
                    ));
            else {
                let A = T[T.length - 1];
                qt.set(e, C, k && X(A) ? k.toDefaultUnit(A) : A);
            }
            return o && s(e, t, T, { duration: d, delay: f, easing: v, repeat: m, offset: j }, "motion-one"), Y.setAnimation(u), u;
        }
    );
}
var we = (e, t) => (e[t] ? Object.assign(Object.assign({}, e), e[t]) : Object.assign({}, e));
function Et(e, t) {
    var r;
    return typeof e == "string" ? (t ? (((r = t[e]) !== null && r !== void 0) || (t[e] = document.querySelectorAll(e)), (e = t[e])) : (e = document.querySelectorAll(e))) : e instanceof Element && (e = [e]), Array.from(e || []);
}
var Ln = (e) => e(),
    _t = (e, t, r = V.duration) => new Proxy({ animations: e.map(Ln).filter(Boolean), duration: r, options: t }, Rn),
    Cn = (e) => e.animations[0],
    Rn = {
        get: (e, t) => {
            let r = Cn(e);
            switch (t) {
                case "duration":
                    return e.duration;
                case "currentTime":
                    return yt.s(r?.[t] || 0);
                case "playbackRate":
                case "playState":
                    return r?.[t];
                case "finished":
                    return e.finished || (e.finished = Promise.all(e.animations.map(Mn)).catch(jt)), e.finished;
                case "stop":
                    return () => {
                        e.animations.forEach((i) => ye(i));
                    };
                case "forEachNative":
                    return (i) => {
                        e.animations.forEach((n) => i(n, e));
                    };
                default:
                    return typeof r?.[t] > "u" ? void 0 : () => e.animations.forEach((i) => i[t]());
            }
        },
        set: (e, t, r) => {
            switch (t) {
                case "currentTime":
                    r = yt.ms(r);
                case "playbackRate":
                    for (let i = 0; i < e.animations.length; i++) e.animations[i][t] = r;
                    return !0;
            }
            return !1;
        },
    },
    Mn = (e) => e.finished;
function qr(e = 0.1, { start: t = 0, from: r = 0, easing: i } = {}) {
    return (n, s) => {
        let o = X(r) ? r : kn(r, s),
            u = Math.abs(o - n),
            d = e * u;
        if (i) {
            let f = s * e;
            d = Ft(i)(d / f) * f;
        }
        return t + d;
    };
}
function kn(e, t) {
    if (e === "first") return 0;
    {
        let r = t - 1;
        return e === "last" ? r : r / 2;
    }
}
function Ee(e, t, r) {
    return q(e) ? e(t, r) : e;
}
function Gr(e) {
    return function (r, i, n = {}) {
        r = Et(r);
        let s = r.length;
        Vt(!!s, "No valid element provided."), Vt(!!i, "No keyframes defined.");
        let o = [];
        for (let u = 0; u < s; u++) {
            let d = r[u];
            for (let f in i) {
                let y = we(n, f);
                y.delay = Ee(y.delay, u, s);
                let m = be(d, f, i[f], y, e);
                o.push(m);
            }
        }
        return _t(o, n, n.duration);
    };
}
var Ue = Gr(ft);
function xe(e, t) {
    var r = {};
    for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
    if (e != null && typeof Object.getOwnPropertySymbols == "function")
        for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++) t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (r[i[n]] = e[i[n]]);
    return r;
}
function qe(e, t, r, i) {
    var n;
    return X(t) ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : t === "<" ? r : (n = i.get(t)) !== null && n !== void 0 ? n : e;
}
function zn(e, t, r) {
    for (let i = 0; i < e.length; i++) {
        let n = e[i];
        n.at > t && n.at < r && (je(e, n), i--);
    }
}
function Zr(e, t, r, i, n, s) {
    zn(e, n, s);
    for (let o = 0; o < t.length; o++) e.push({ value: t[o], at: Tt(n, s, i[o]), easing: zt(r, o) });
}
function Xr(e, t) {
    return e.at === t.at ? (e.value === null ? 1 : -1) : e.at - t.at;
}
function Yr(e, t = {}) {
    var r;
    let i = jn(e, t),
        n = i.map((s) => be(...s, ft)).filter(Boolean);
    return _t(n, t, (r = i[0]) === null || r === void 0 ? void 0 : r[3].duration);
}
function jn(e, t = {}) {
    var { defaultOptions: r = {} } = t,
        i = xe(t, ["defaultOptions"]);
    let n = [],
        s = new Map(),
        o = {},
        u = new Map(),
        d = 0,
        f = 0,
        y = 0;
    for (let m = 0; m < e.length; m++) {
        let v = e[m];
        if (ut(v)) {
            u.set(v, f);
            continue;
        } else if (!Array.isArray(v)) {
            u.set(v.name, qe(f, v.at, d, u));
            continue;
        }
        let [_, z, j = {}] = v;
        j.at !== void 0 && (f = qe(f, j.at, d, u));
        let R = 0,
            B = Et(_, o),
            P = B.length;
        for (let F = 0; F < P; F++) {
            let C = B[F],
                Y = $n(C, s);
            for (let k in z) {
                let tt = Wn(k, Y),
                    T = ge(z[k]),
                    et = we(j, k),
                    { duration: A = r.duration || V.duration, easing: S = r.easing || V.easing } = et;
                if (gt(S)) {
                    Vt(k === "opacity" || T.length > 1, "spring must be provided 2 keyframes within timeline()");
                    let L = S.createAnimation(T, k !== "opacity", () => 0, k);
                    (S = L.easing), (T = L.keyframes || T), (A = L.duration || A);
                }
                let a = Ee(j.delay, F, P) || 0,
                    l = f + a,
                    g = l + A,
                    { offset: x = At(T.length) } = et;
                x.length === 1 && x[0] === 0 && (x[1] = 1);
                let I = x.length - T.length;
                I > 0 && Pt(x, I), T.length === 1 && T.unshift(null), Zr(tt, T, S, x, l, g), (R = Math.max(a + A, R)), (y = Math.max(g, y));
            }
        }
        (d = f), (f += R);
    }
    return (
        s.forEach((m, v) => {
            for (let _ in m) {
                let z = m[_];
                z.sort(Xr);
                let j = [],
                    R = [],
                    B = [];
                for (let P = 0; P < z.length; P++) {
                    let { at: F, value: C, easing: Y } = z[P];
                    j.push(C), R.push(ot(0, y, F)), B.push(Y || V.easing);
                }
                R[0] !== 0 && (R.unshift(0), j.unshift(j[0]), B.unshift("linear")),
                    R[R.length - 1] !== 1 && (R.push(1), j.push(null)),
                    n.push([v, _, j, Object.assign(Object.assign(Object.assign({}, r), { duration: y, easing: B, offset: R }), i)]);
            }
        }),
        n
    );
}
function $n(e, t) {
    return !t.has(e) && t.set(e, {}), t.get(e);
}
function Wn(e, t) {
    return t[e] || (t[e] = []), t[e];
}
var Vn = { any: 0, all: 1 };
function Qr(e, t, { root: r, margin: i, amount: n = "any" } = {}) {
    if (typeof IntersectionObserver > "u") return () => {};
    let s = Et(e),
        o = new WeakMap(),
        u = (f) => {
            f.forEach((y) => {
                let m = o.get(y.target);
                if (y.isIntersecting !== !!m)
                    if (y.isIntersecting) {
                        let v = t(y);
                        q(v) ? o.set(y.target, v) : d.unobserve(y.target);
                    } else m && (m(y), o.delete(y.target));
            });
        },
        d = new IntersectionObserver(u, { root: r, rootMargin: i, threshold: typeof n == "number" ? n : Vn[n] });
    return s.forEach((f) => d.observe(f)), () => d.disconnect();
}
var Se = new WeakMap(),
    xt;
function Bn(e, t) {
    if (t) {
        let { inlineSize: r, blockSize: i } = t[0];
        return { width: r, height: i };
    } else return e instanceof SVGElement && "getBBox" in e ? e.getBBox() : { width: e.offsetWidth, height: e.offsetHeight };
}
function Hn({ target: e, contentRect: t, borderBoxSize: r }) {
    var i;
    (i = Se.get(e)) === null ||
        i === void 0 ||
        i.forEach((n) => {
            n({
                target: e,
                contentSize: t,
                get size() {
                    return Bn(e, r);
                },
            });
        });
}
function Kn(e) {
    e.forEach(Hn);
}
function Un() {
    typeof ResizeObserver > "u" || (xt = new ResizeObserver(Kn));
}
function Jr(e, t) {
    xt || Un();
    let r = Et(e);
    return (
        r.forEach((i) => {
            let n = Se.get(i);
            n || ((n = new Set()), Se.set(i, n)), n.add(t), xt?.observe(i);
        }),
        () => {
            r.forEach((i) => {
                let n = Se.get(i);
                n?.delete(t), n?.size || xt?.unobserve(i);
            });
        }
    );
}
var Oe = new Set(),
    Gt;
function qn() {
    (Gt = () => {
        let e = { width: window.innerWidth, height: window.innerHeight },
            t = { target: window, size: e, contentSize: e };
        Oe.forEach((r) => r(t));
    }),
        window.addEventListener("resize", Gt);
}
function ti(e) {
    return (
        Oe.add(e),
        Gt || qn(),
        () => {
            Oe.delete(e), !Oe.size && Gt && (Gt = void 0);
        }
    );
}
function ei(e, t) {
    return q(e) ? ti(e) : Jr(e, t);
}
var Gn = 50,
    ri = () => ({ current: 0, offset: [], progress: 0, scrollLength: 0, targetOffset: 0, targetLength: 0, containerLength: 0, velocity: 0 }),
    ni = () => ({ time: 0, x: ri(), y: ri() }),
    Zn = { x: { length: "Width", position: "Left" }, y: { length: "Height", position: "Top" } };
function ii(e, t, r, i) {
    let n = r[t],
        { length: s, position: o } = Zn[t],
        u = n.current,
        d = r.time;
    (n.current = e["scroll" + o]), (n.scrollLength = e["scroll" + s] - e["client" + s]), (n.offset.length = 0), (n.offset[0] = 0), (n.offset[1] = n.scrollLength), (n.progress = ot(0, n.scrollLength, n.current));
    let f = i - d;
    n.velocity = f > Gn ? 0 : $e(n.current - u, f);
}
function oi(e, t, r) {
    ii(e, "x", t, r), ii(e, "y", t, r), (t.time = r);
}
function si(e, t) {
    let r = { x: 0, y: 0 },
        i = e;
    for (; i && i !== t; )
        if (i instanceof HTMLElement) (r.x += i.offsetLeft), (r.y += i.offsetTop), (i = i.offsetParent);
        else if (i instanceof SVGGraphicsElement && "getBBox" in i) {
            let { top: n, left: s } = i.getBBox();
            for (r.x += s, r.y += n; i && i.tagName !== "svg"; ) i = i.parentNode;
        }
    return r;
}
var Te = {
    Enter: [
        [0, 1],
        [1, 1],
    ],
    Exit: [
        [0, 0],
        [1, 0],
    ],
    Any: [
        [1, 0],
        [0, 1],
    ],
    All: [
        [0, 0],
        [1, 1],
    ],
};
var Ae = { start: 0, center: 0.5, end: 1 };
function Ge(e, t, r = 0) {
    let i = 0;
    if ((Ae[e] !== void 0 && (e = Ae[e]), ut(e))) {
        let n = parseFloat(e);
        e.endsWith("px") ? (i = n) : e.endsWith("%") ? (e = n / 100) : e.endsWith("vw") ? (i = (n / 100) * document.documentElement.clientWidth) : e.endsWith("vh") ? (i = (n / 100) * document.documentElement.clientHeight) : (e = n);
    }
    return X(e) && (i = t * e), r + i;
}
var Xn = [0, 0];
function ai(e, t, r, i) {
    let n = Array.isArray(e) ? e : Xn,
        s = 0,
        o = 0;
    return X(e) ? (n = [e, e]) : ut(e) && ((e = e.trim()), e.includes(" ") ? (n = e.split(" ")) : (n = [e, Ae[e] ? e : "0"])), (s = Ge(n[0], r, i)), (o = Ge(n[1], t)), s - o;
}
var Yn = { x: 0, y: 0 };
function li(e, t, r) {
    let { offset: i = Te.All } = r,
        { target: n = e, axis: s = "y" } = r,
        o = s === "y" ? "height" : "width",
        u = n !== e ? si(n, e) : Yn,
        d = n === e ? { width: e.scrollWidth, height: e.scrollHeight } : { width: n.clientWidth, height: n.clientHeight },
        f = { width: e.clientWidth, height: e.clientHeight };
    t[s].offset.length = 0;
    let y = !t[s].interpolate,
        m = i.length;
    for (let v = 0; v < m; v++) {
        let _ = ai(i[v], f[o], d[o], u[s]);
        !y && _ !== t[s].interpolatorOffsets[v] && (y = !0), (t[s].offset[v] = _);
    }
    y && ((t[s].interpolate = $t(At(m), t[s].offset)), (t[s].interpolatorOffsets = [...t[s].offset])), (t[s].progress = t[s].interpolate(t[s].current));
}
function Qn(e, t = e, r) {
    if (((r.x.targetOffset = 0), (r.y.targetOffset = 0), t !== e)) {
        let i = t;
        for (; i && i != e; ) (r.x.targetOffset += i.offsetLeft), (r.y.targetOffset += i.offsetTop), (i = i.offsetParent);
    }
    (r.x.targetLength = t === e ? t.scrollWidth : t.clientWidth), (r.y.targetLength = t === e ? t.scrollHeight : t.clientHeight), (r.x.containerLength = e.clientWidth), (r.y.containerLength = e.clientHeight);
}
function ci(e, t, r, i = {}) {
    let n = i.axis || "y";
    return {
        measure: () => Qn(e, i.target, r),
        update: (s) => {
            oi(e, r, s), (i.offset || i.target) && li(e, r, i);
        },
        notify: q(t) ? () => t(r) : Jn(t, r[n]),
    };
}
function Jn(e, t) {
    return (
        e.pause(),
        e.forEachNative((r, { easing: i }) => {
            var n, s;
            if (r.updateDuration) i || (r.easing = G), r.updateDuration(1);
            else {
                let o = { duration: 1e3 };
                i || (o.easing = "linear"), (s = (n = r.effect) === null || n === void 0 ? void 0 : n.updateTiming) === null || s === void 0 || s.call(n, o);
            }
        }),
        () => {
            e.currentTime = t.progress;
        }
    );
}
var Zt = new WeakMap(),
    ui = new WeakMap(),
    Ze = new WeakMap(),
    fi = (e) => (e === document.documentElement ? window : e);
function di(e, t = {}) {
    var { container: r = document.documentElement } = t,
        i = xe(t, ["container"]);
    let n = Ze.get(r);
    n || ((n = new Set()), Ze.set(r, n));
    let s = ni(),
        o = ci(r, e, s, i);
    if ((n.add(o), !Zt.has(r))) {
        let f = () => {
            let m = performance.now();
            for (let v of n) v.measure();
            for (let v of n) v.update(m);
            for (let v of n) v.notify();
        };
        Zt.set(r, f);
        let y = fi(r);
        window.addEventListener("resize", f, { passive: !0 }), r !== document.documentElement && ui.set(r, ei(r, f)), y.addEventListener("scroll", f, { passive: !0 });
    }
    let u = Zt.get(r),
        d = requestAnimationFrame(u);
    return () => {
        var f;
        typeof e != "function" && e.stop(), cancelAnimationFrame(d);
        let y = Ze.get(r);
        if (!y || (y.delete(o), y.size)) return;
        let m = Zt.get(r);
        Zt.delete(r), m && (fi(r).removeEventListener("scroll", m), (f = ui.get(r)) === null || f === void 0 || f(), window.removeEventListener("resize", m));
    };
}
function to(e, t = {}) {
    return _t(
        [
            () => {
                let r = new ft(e, [0, 1], t);
                return r.finished.catch(() => {}), r;
            },
        ],
        t,
        t.duration
    );
}
function hi(e, t, r) {
    return (q(e) ? to : Ue)(e, t, r);
}
function dt(e) {
    (this.listenerMap = [{}, {}]), e && this.root(e), (this.handle = dt.prototype.handle.bind(this)), (this._removedListeners = []);
}
dt.prototype.root = function (e) {
    let t = this.listenerMap,
        r;
    if (this.rootElement) {
        for (r in t[1]) t[1].hasOwnProperty(r) && this.rootElement.removeEventListener(r, this.handle, !0);
        for (r in t[0]) t[0].hasOwnProperty(r) && this.rootElement.removeEventListener(r, this.handle, !1);
    }
    if (!e || !e.addEventListener) return this.rootElement && delete this.rootElement, this;
    this.rootElement = e;
    for (r in t[1]) t[1].hasOwnProperty(r) && this.rootElement.addEventListener(r, this.handle, !0);
    for (r in t[0]) t[0].hasOwnProperty(r) && this.rootElement.addEventListener(r, this.handle, !1);
    return this;
};
dt.prototype.captureForType = function (e) {
    return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(e) !== -1;
};
dt.prototype.on = function (e, t, r, i) {
    let n, s, o, u;
    if (!e) throw new TypeError("Invalid event type: " + e);
    if ((typeof t == "function" && ((i = r), (r = t), (t = null)), i === void 0 && (i = this.captureForType(e)), typeof r != "function")) throw new TypeError("Handler must be a type of Function");
    return (
        (n = this.rootElement),
        (s = this.listenerMap[i ? 1 : 0]),
        s[e] || (n && n.addEventListener(e, this.handle, i), (s[e] = [])),
        t ? (/^[a-z]+$/i.test(t) ? ((u = t), (o = eo)) : /^#[a-z0-9\-_]+$/i.test(t) ? ((u = t.slice(1)), (o = io)) : ((u = t), (o = Element.prototype.matches))) : ((u = null), (o = ro.bind(this))),
        s[e].push({ selector: t, handler: r, matcher: o, matcherParam: u }),
        this
    );
};
dt.prototype.off = function (e, t, r, i) {
    let n, s, o, u, d;
    if ((typeof t == "function" && ((i = r), (r = t), (t = null)), i === void 0)) return this.off(e, t, r, !0), this.off(e, t, r, !1), this;
    if (((o = this.listenerMap[i ? 1 : 0]), !e)) {
        for (d in o) o.hasOwnProperty(d) && this.off(d, t, r);
        return this;
    }
    if (((u = o[e]), !u || !u.length)) return this;
    for (n = u.length - 1; n >= 0; n--) (s = u[n]), (!t || t === s.selector) && (!r || r === s.handler) && (this._removedListeners.push(s), u.splice(n, 1));
    return u.length || (delete o[e], this.rootElement && this.rootElement.removeEventListener(e, this.handle, i)), this;
};
dt.prototype.handle = function (e) {
    let t,
        r,
        i = e.type,
        n,
        s,
        o,
        u,
        d = [],
        f,
        y = "ftLabsDelegateIgnore";
    if (e[y] === !0) return;
    switch (((f = e.target), f.nodeType === 3 && (f = f.parentNode), f.correspondingUseElement && (f = f.correspondingUseElement), (n = this.rootElement), (s = e.eventPhase || (e.target !== e.currentTarget ? 3 : 2)), s)) {
        case 1:
            d = this.listenerMap[1][i];
            break;
        case 2:
            this.listenerMap[0] && this.listenerMap[0][i] && (d = d.concat(this.listenerMap[0][i])), this.listenerMap[1] && this.listenerMap[1][i] && (d = d.concat(this.listenerMap[1][i]));
            break;
        case 3:
            d = this.listenerMap[0][i];
            break;
    }
    let m = [];
    for (r = d.length; f && r; ) {
        for (t = 0; t < r && ((o = d[t]), !!o); t++)
            f.tagName && ["button", "input", "select", "textarea"].indexOf(f.tagName.toLowerCase()) > -1 && f.hasAttribute("disabled") ? (m = []) : o.matcher.call(f, o.matcherParam, f) && m.push([e, f, o]);
        if (f === n || ((r = d.length), (f = f.parentElement || f.parentNode), f instanceof HTMLDocument)) break;
    }
    let v;
    for (t = 0; t < m.length; t++)
        if (!(this._removedListeners.indexOf(m[t][2]) > -1) && ((u = this.fire.apply(this, m[t])), u === !1)) {
            (m[t][0][y] = !0), m[t][0].preventDefault(), (v = !1);
            break;
        }
    return v;
};
dt.prototype.fire = function (e, t, r) {
    return r.handler.call(t, e, t);
};
function eo(e, t) {
    return e.toLowerCase() === t.tagName.toLowerCase();
}
function ro(e, t) {
    return this.rootElement === window ? t === document || t === document.documentElement || t === window : this.rootElement === t;
}
function io(e, t) {
    return e === t.id;
}
dt.prototype.destroy = function () {
    this.off(), this.root();
};
var no = dt;
function Xt(e, t, r) {
    let i = document.createElement(t);
    return e && (i.className = e), r && r.appendChild(i), i;
}
function oo(e, t, r) {
    let i = `translate3d(${e}px,${t || 0}px,0)`;
    return r !== void 0 && (i += ` scale3d(${r},${r},1)`), i;
}
function Xe(e, t, r) {
    (e.style.width = typeof t == "number" ? `${t}px` : t), (e.style.height = typeof r == "number" ? `${r}px` : r);
}
var it = { IDLE: "idle", LOADING: "loading", LOADED: "loaded", ERROR: "error" };
function so(e) {
    return ("button" in e && e.button === 1) || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
}
function Yt(e, t, r = document) {
    let i = [];
    if (e instanceof Element) i = [e];
    else if (e instanceof NodeList || Array.isArray(e)) i = Array.from(e);
    else {
        let n = typeof e == "string" ? e : t;
        n && (i = Array.from(r.querySelectorAll(n)));
    }
    return i;
}
function ao(e) {
    return typeof e == "function" && e.prototype && e.prototype.goTo;
}
function pi() {
    return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}
var Ye = class {
        constructor(t, r) {
            (this.type = t), (this.defaultPrevented = !1), r && Object.assign(this, r);
        }
        preventDefault() {
            this.defaultPrevented = !0;
        }
    },
    Qe = class {
        constructor() {
            (this._listeners = {}), (this._filters = {}), (this.pswp = void 0), (this.options = void 0);
        }
        addFilter(t, r, i = 100) {
            var n, s, o;
            this._filters[t] || (this._filters[t] = []),
                (n = this._filters[t]) === null || n === void 0 || n.push({ fn: r, priority: i }),
                (s = this._filters[t]) === null || s === void 0 || s.sort((u, d) => u.priority - d.priority),
                (o = this.pswp) === null || o === void 0 || o.addFilter(t, r, i);
        }
        removeFilter(t, r) {
            this._filters[t] && (this._filters[t] = this._filters[t].filter((i) => i.fn !== r)), this.pswp && this.pswp.removeFilter(t, r);
        }
        applyFilters(t, ...r) {
            var i;
            return (
                (i = this._filters[t]) === null ||
                    i === void 0 ||
                    i.forEach((n) => {
                        r[0] = n.fn.apply(this, r);
                    }),
                r[0]
            );
        }
        on(t, r) {
            var i, n;
            this._listeners[t] || (this._listeners[t] = []), (i = this._listeners[t]) === null || i === void 0 || i.push(r), (n = this.pswp) === null || n === void 0 || n.on(t, r);
        }
        off(t, r) {
            var i;
            this._listeners[t] && (this._listeners[t] = this._listeners[t].filter((n) => r !== n)), (i = this.pswp) === null || i === void 0 || i.off(t, r);
        }
        dispatch(t, r) {
            var i;
            if (this.pswp) return this.pswp.dispatch(t, r);
            let n = new Ye(t, r);
            return (
                (i = this._listeners[t]) === null ||
                    i === void 0 ||
                    i.forEach((s) => {
                        s.call(this, n);
                    }),
                n
            );
        }
    },
    Je = class {
        constructor(t, r) {
            if (((this.element = Xt("pswp__img pswp__img--placeholder", t ? "img" : "div", r)), t)) {
                let i = this.element;
                (i.decoding = "async"), (i.alt = ""), (i.src = t), i.setAttribute("role", "presentation");
            }
            this.element.setAttribute("aria-hidden", "true");
        }
        setDisplayedSize(t, r) {
            this.element && (this.element.tagName === "IMG" ? (Xe(this.element, 250, "auto"), (this.element.style.transformOrigin = "0 0"), (this.element.style.transform = oo(0, 0, t / 250))) : Xe(this.element, t, r));
        }
        destroy() {
            var t;
            (t = this.element) !== null && t !== void 0 && t.parentNode && this.element.remove(), (this.element = null);
        }
    },
    tr = class {
        constructor(t, r, i) {
            (this.instance = r),
                (this.data = t),
                (this.index = i),
                (this.element = void 0),
                (this.placeholder = void 0),
                (this.slide = void 0),
                (this.displayedImageWidth = 0),
                (this.displayedImageHeight = 0),
                (this.width = Number(this.data.w) || Number(this.data.width) || 0),
                (this.height = Number(this.data.h) || Number(this.data.height) || 0),
                (this.isAttached = !1),
                (this.hasSlide = !1),
                (this.isDecoding = !1),
                (this.state = it.IDLE),
                this.data.type ? (this.type = this.data.type) : this.data.src ? (this.type = "image") : (this.type = "html"),
                this.instance.dispatch("contentInit", { content: this });
        }
        removePlaceholder() {
            this.placeholder &&
                !this.keepPlaceholder() &&
                setTimeout(() => {
                    this.placeholder && (this.placeholder.destroy(), (this.placeholder = void 0));
                }, 1e3);
        }
        load(t, r) {
            if (this.slide && this.usePlaceholder())
                if (this.placeholder) {
                    let i = this.placeholder.element;
                    i && !i.parentElement && this.slide.container.prepend(i);
                } else {
                    let i = this.instance.applyFilters("placeholderSrc", this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : !1, this);
                    this.placeholder = new Je(i, this.slide.container);
                }
            (this.element && !r) ||
                this.instance.dispatch("contentLoad", { content: this, isLazy: t }).defaultPrevented ||
                (this.isImageContent() ? ((this.element = Xt("pswp__img", "img")), this.displayedImageWidth && this.loadImage(t)) : ((this.element = Xt("pswp__content", "div")), (this.element.innerHTML = this.data.html || "")),
                r && this.slide && this.slide.updateContentSize(!0));
        }
        loadImage(t) {
            var r, i;
            if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", { content: this, isLazy: t }).defaultPrevented) return;
            let n = this.element;
            this.updateSrcsetSizes(),
                this.data.srcset && (n.srcset = this.data.srcset),
                (n.src = (r = this.data.src) !== null && r !== void 0 ? r : ""),
                (n.alt = (i = this.data.alt) !== null && i !== void 0 ? i : ""),
                (this.state = it.LOADING),
                n.complete
                    ? this.onLoaded()
                    : ((n.onload = () => {
                          this.onLoaded();
                      }),
                      (n.onerror = () => {
                          this.onError();
                      }));
        }
        setSlide(t) {
            (this.slide = t), (this.hasSlide = !0), (this.instance = t.pswp);
        }
        onLoaded() {
            (this.state = it.LOADED),
                this.slide &&
                    this.element &&
                    (this.instance.dispatch("loadComplete", { slide: this.slide, content: this }),
                    this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode && (this.append(), this.slide.updateContentSize(!0)),
                    (this.state === it.LOADED || this.state === it.ERROR) && this.removePlaceholder());
        }
        onError() {
            (this.state = it.ERROR), this.slide && (this.displayError(), this.instance.dispatch("loadComplete", { slide: this.slide, isError: !0, content: this }), this.instance.dispatch("loadError", { slide: this.slide, content: this }));
        }
        isLoading() {
            return this.instance.applyFilters("isContentLoading", this.state === it.LOADING, this);
        }
        isError() {
            return this.state === it.ERROR;
        }
        isImageContent() {
            return this.type === "image";
        }
        setDisplayedSize(t, r) {
            if (
                this.element &&
                (this.placeholder && this.placeholder.setDisplayedSize(t, r),
                !this.instance.dispatch("contentResize", { content: this, width: t, height: r }).defaultPrevented && (Xe(this.element, t, r), this.isImageContent() && !this.isError()))
            ) {
                let i = !this.displayedImageWidth && t;
                (this.displayedImageWidth = t),
                    (this.displayedImageHeight = r),
                    i ? this.loadImage(!1) : this.updateSrcsetSizes(),
                    this.slide && this.instance.dispatch("imageSizeChange", { slide: this.slide, width: t, height: r, content: this });
            }
        }
        isZoomable() {
            return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== it.ERROR, this);
        }
        updateSrcsetSizes() {
            if (!this.isImageContent() || !this.element || !this.data.srcset) return;
            let t = this.element,
                r = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
            (!t.dataset.largestUsedSize || r > parseInt(t.dataset.largestUsedSize, 10)) && ((t.sizes = r + "px"), (t.dataset.largestUsedSize = String(r)));
        }
        usePlaceholder() {
            return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this);
        }
        lazyLoad() {
            this.instance.dispatch("contentLazyLoad", { content: this }).defaultPrevented || this.load(!0);
        }
        keepPlaceholder() {
            return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this);
        }
        destroy() {
            (this.hasSlide = !1),
                (this.slide = void 0),
                !this.instance.dispatch("contentDestroy", { content: this }).defaultPrevented &&
                    (this.remove(),
                    this.placeholder && (this.placeholder.destroy(), (this.placeholder = void 0)),
                    this.isImageContent() && this.element && ((this.element.onload = null), (this.element.onerror = null), (this.element = void 0)));
        }
        displayError() {
            if (this.slide) {
                var t, r;
                let i = Xt("pswp__error-msg", "div");
                (i.innerText = (t = (r = this.instance.options) === null || r === void 0 ? void 0 : r.errorMsg) !== null && t !== void 0 ? t : ""),
                    (i = this.instance.applyFilters("contentErrorElement", i, this)),
                    (this.element = Xt("pswp__content pswp__error-msg-container", "div")),
                    this.element.appendChild(i),
                    (this.slide.container.innerText = ""),
                    this.slide.container.appendChild(this.element),
                    this.slide.updateContentSize(!0),
                    this.removePlaceholder();
            }
        }
        append() {
            if (this.isAttached || !this.element) return;
            if (((this.isAttached = !0), this.state === it.ERROR)) {
                this.displayError();
                return;
            }
            if (this.instance.dispatch("contentAppend", { content: this }).defaultPrevented) return;
            let t = "decode" in this.element;
            this.isImageContent()
                ? t && this.slide && (!this.slide.isActive || pi())
                    ? ((this.isDecoding = !0),
                      this.element
                          .decode()
                          .catch(() => {})
                          .finally(() => {
                              (this.isDecoding = !1), this.appendImage();
                          }))
                    : this.appendImage()
                : this.slide && !this.element.parentNode && this.slide.container.appendChild(this.element);
        }
        activate() {
            this.instance.dispatch("contentActivate", { content: this }).defaultPrevented ||
                !this.slide ||
                (this.isImageContent() && this.isDecoding && !pi() ? this.appendImage() : this.isError() && this.load(!1, !0), this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "false"));
        }
        deactivate() {
            this.instance.dispatch("contentDeactivate", { content: this }), this.slide && this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "true");
        }
        remove() {
            (this.isAttached = !1),
                !this.instance.dispatch("contentRemove", { content: this }).defaultPrevented &&
                    (this.element && this.element.parentNode && this.element.remove(), this.placeholder && this.placeholder.element && this.placeholder.element.remove());
        }
        appendImage() {
            this.isAttached &&
                (this.instance.dispatch("contentAppendImage", { content: this }).defaultPrevented ||
                    (this.slide && this.element && !this.element.parentNode && this.slide.container.appendChild(this.element), (this.state === it.LOADED || this.state === it.ERROR) && this.removePlaceholder()));
        }
    };
function lo(e, t) {
    if (e.getViewportSizeFn) {
        let r = e.getViewportSizeFn(e, t);
        if (r) return r;
    }
    return { x: document.documentElement.clientWidth, y: window.innerHeight };
}
function Ie(e, t, r, i, n) {
    let s = 0;
    if (t.paddingFn) s = t.paddingFn(r, i, n)[e];
    else if (t.padding) s = t.padding[e];
    else {
        let o = "padding" + e[0].toUpperCase() + e.slice(1);
        t[o] && (s = t[o]);
    }
    return Number(s) || 0;
}
function co(e, t, r, i) {
    return { x: t.x - Ie("left", e, t, r, i) - Ie("right", e, t, r, i), y: t.y - Ie("top", e, t, r, i) - Ie("bottom", e, t, r, i) };
}
var mi = 4e3,
    er = class {
        constructor(t, r, i, n) {
            (this.pswp = n),
                (this.options = t),
                (this.itemData = r),
                (this.index = i),
                (this.panAreaSize = null),
                (this.elementSize = null),
                (this.fit = 1),
                (this.fill = 1),
                (this.vFill = 1),
                (this.initial = 1),
                (this.secondary = 1),
                (this.max = 1),
                (this.min = 1);
        }
        update(t, r, i) {
            let n = { x: t, y: r };
            (this.elementSize = n), (this.panAreaSize = i);
            let s = i.x / n.x,
                o = i.y / n.y;
            (this.fit = Math.min(1, s < o ? s : o)),
                (this.fill = Math.min(1, s > o ? s : o)),
                (this.vFill = Math.min(1, o)),
                (this.initial = this._getInitial()),
                (this.secondary = this._getSecondary()),
                (this.max = Math.max(this.initial, this.secondary, this._getMax())),
                (this.min = Math.min(this.fit, this.initial, this.secondary)),
                this.pswp && this.pswp.dispatch("zoomLevelsUpdate", { zoomLevels: this, slideData: this.itemData });
        }
        _parseZoomLevelOption(t) {
            let r = t + "ZoomLevel",
                i = this.options[r];
            if (i) return typeof i == "function" ? i(this) : i === "fill" ? this.fill : i === "fit" ? this.fit : Number(i);
        }
        _getSecondary() {
            let t = this._parseZoomLevelOption("secondary");
            return t || ((t = Math.min(1, this.fit * 3)), this.elementSize && t * this.elementSize.x > mi && (t = mi / this.elementSize.x), t);
        }
        _getInitial() {
            return this._parseZoomLevelOption("initial") || this.fit;
        }
        _getMax() {
            return this._parseZoomLevelOption("max") || Math.max(1, this.fit * 4);
        }
    };
function vi(e, t, r) {
    let i = t.createContentFromData(e, r),
        n,
        { options: s } = t;
    if (s) {
        n = new er(s, e, -1);
        let o;
        t.pswp ? (o = t.pswp.viewportSize) : (o = lo(s, t));
        let u = co(s, o, e, r);
        n.update(i.width, i.height, u);
    }
    return i.lazyLoad(), n && i.setDisplayedSize(Math.ceil(i.width * n.initial), Math.ceil(i.height * n.initial)), i;
}
function uo(e, t) {
    let r = t.getItemData(e);
    if (!t.dispatch("lazyLoadSlide", { index: e, itemData: r }).defaultPrevented) return vi(r, t, e);
}
var rr = class extends Qe {
        getNumItems() {
            var t;
            let r = 0,
                i = (t = this.options) === null || t === void 0 ? void 0 : t.dataSource;
            i && "length" in i ? (r = i.length) : i && "gallery" in i && (i.items || (i.items = this._getGalleryDOMElements(i.gallery)), i.items && (r = i.items.length));
            let n = this.dispatch("numItems", { dataSource: i, numItems: r });
            return this.applyFilters("numItems", n.numItems, i);
        }
        createContentFromData(t, r) {
            return new tr(t, this, r);
        }
        getItemData(t) {
            var r;
            let i = (r = this.options) === null || r === void 0 ? void 0 : r.dataSource,
                n = {};
            Array.isArray(i) ? (n = i[t]) : i && "gallery" in i && (i.items || (i.items = this._getGalleryDOMElements(i.gallery)), (n = i.items[t]));
            let s = n;
            s instanceof Element && (s = this._domElementToItemData(s));
            let o = this.dispatch("itemData", { itemData: s || {}, index: t });
            return this.applyFilters("itemData", o.itemData, t);
        }
        _getGalleryDOMElements(t) {
            var r, i;
            return ((r = this.options) !== null && r !== void 0 && r.children) || ((i = this.options) !== null && i !== void 0 && i.childSelector) ? Yt(this.options.children, this.options.childSelector, t) || [] : [t];
        }
        _domElementToItemData(t) {
            let r = { element: t },
                i = t.tagName === "A" ? t : t.querySelector("a");
            if (i) {
                (r.src = i.dataset.pswpSrc || i.href),
                    i.dataset.pswpSrcset && (r.srcset = i.dataset.pswpSrcset),
                    (r.width = i.dataset.pswpWidth ? parseInt(i.dataset.pswpWidth, 10) : 0),
                    (r.height = i.dataset.pswpHeight ? parseInt(i.dataset.pswpHeight, 10) : 0),
                    (r.w = r.width),
                    (r.h = r.height),
                    i.dataset.pswpType && (r.type = i.dataset.pswpType);
                let s = t.querySelector("img");
                if (s) {
                    var n;
                    (r.msrc = s.currentSrc || s.src), (r.alt = (n = s.getAttribute("alt")) !== null && n !== void 0 ? n : "");
                }
                (i.dataset.pswpCropped || i.dataset.cropped) && (r.thumbCropped = !0);
            }
            return this.applyFilters("domItemData", r, t, i);
        }
        lazyLoadData(t, r) {
            return vi(t, this, r);
        }
    },
    ir = class extends rr {
        constructor(t) {
            super(), (this.options = t || {}), (this._uid = 0), (this.shouldOpen = !1), (this._preloadedContent = void 0), (this.onThumbnailsClick = this.onThumbnailsClick.bind(this));
        }
        init() {
            Yt(this.options.gallery, this.options.gallerySelector).forEach((t) => {
                t.addEventListener("click", this.onThumbnailsClick, !1);
            });
        }
        onThumbnailsClick(t) {
            if (so(t) || window.pswp) return;
            let r = { x: t.clientX, y: t.clientY };
            !r.x && !r.y && (r = null);
            let i = this.getClickedIndex(t);
            i = this.applyFilters("clickedIndex", i, t, this);
            let n = { gallery: t.currentTarget };
            i >= 0 && (t.preventDefault(), this.loadAndOpen(i, n, r));
        }
        getClickedIndex(t) {
            if (this.options.getClickedIndexFn) return this.options.getClickedIndexFn.call(this, t);
            let r = t.target,
                n = Yt(this.options.children, this.options.childSelector, t.currentTarget).findIndex((s) => s === r || s.contains(r));
            return n !== -1 ? n : this.options.children || this.options.childSelector ? -1 : 0;
        }
        loadAndOpen(t, r, i) {
            if (window.pswp || !this.options) return !1;
            if (!r && this.options.gallery && this.options.children) {
                let n = Yt(this.options.gallery);
                n[0] && (r = { gallery: n[0] });
            }
            return (this.options.index = t), (this.options.initialPointerPos = i), (this.shouldOpen = !0), this.preload(t, r), !0;
        }
        preload(t, r) {
            let { options: i } = this;
            r && (i.dataSource = r);
            let n = [],
                s = typeof i.pswpModule;
            if (ao(i.pswpModule)) n.push(Promise.resolve(i.pswpModule));
            else {
                if (s === "string") throw new Error("pswpModule as string is no longer supported");
                if (s === "function") n.push(i.pswpModule());
                else throw new Error("pswpModule is not valid");
            }
            typeof i.openPromise == "function" && n.push(i.openPromise()), i.preloadFirstSlide !== !1 && t >= 0 && (this._preloadedContent = uo(t, this));
            let o = ++this._uid;
            Promise.all(n).then((u) => {
                if (this.shouldOpen) {
                    let d = u[0];
                    this._openPhotoswipe(d, o);
                }
            });
        }
        _openPhotoswipe(t, r) {
            if ((r !== this._uid && this.shouldOpen) || ((this.shouldOpen = !1), window.pswp)) return;
            let i = typeof t == "object" ? new t.default(this.options) : new t(this.options);
            (this.pswp = i),
                (window.pswp = i),
                Object.keys(this._listeners).forEach((n) => {
                    var s;
                    (s = this._listeners[n]) === null ||
                        s === void 0 ||
                        s.forEach((o) => {
                            i.on(n, o);
                        });
                }),
                Object.keys(this._filters).forEach((n) => {
                    var s;
                    (s = this._filters[n]) === null ||
                        s === void 0 ||
                        s.forEach((o) => {
                            i.addFilter(n, o.fn, o.priority);
                        });
                }),
                this._preloadedContent && (i.contentLoader.addToCache(this._preloadedContent), (this._preloadedContent = void 0)),
                i.on("destroy", () => {
                    (this.pswp = void 0), delete window.pswp;
                }),
                i.init();
        }
        destroy() {
            var t;
            (t = this.pswp) === null || t === void 0 || t.destroy(),
                (this.shouldOpen = !1),
                (this._listeners = {}),
                Yt(this.options.gallery, this.options.gallerySelector).forEach((r) => {
                    r.removeEventListener("click", this.onThumbnailsClick, !1);
                });
        }
    };
(function () {
    Node.prototype.replaceChildren === void 0 &&
        (Node.prototype.replaceChildren = (e) => {
            for (; this.lastChild; ) this.removeChild(this.lastChild);
            e !== void 0 && this.append(e);
        });
})();
(function () {
    let e = !1;
    if (
        (document.createElement("i").addEventListener("click", () => {}, {
            get signal() {
                e = !0;
            },
        }),
        e || !window.AbortController)
    )
        return;
    let t = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function (r, i, n) {
        if (n && n.signal) {
            if (n.signal.aborted) return;
            n.signal.addEventListener("abort", () => this.removeEventListener(r, i, { ...n }));
        }
        return t.call(this, r, i, n);
    };
})();
function throttle2(callback){let requestId=null,lastArgs;const later=context=>()=>{requestId=null,callback.apply(context,lastArgs)},throttled=(...args)=>{lastArgs=args,requestId===null&&(requestId=requestAnimationFrame(later(this)))};return throttled.cancel=()=>{cancelAnimationFrame(requestId),requestId=null},throttled}function debounce1(fn,delay){let timer=null;return(...args)=>{clearTimeout(timer),timer=setTimeout(()=>{fn.apply(this,args)},delay)}}


// import { animate as animate3, timeline as timeline5, inView as inView3 } from "vendor.min.js";
// import { getHeadingKeyframe as getHeadingKeyframe2, throttle as throttle2 } from "theme.js";


var ImagesWithTextScrolling = class extends HTMLElement {
  connectedCallback() {
    Qr(this, this._reveal.bind(this)),
        this.hasAttribute("scrolling-experience") &&
            ((this._imageToTransitionItems = Array.from(this.querySelectorAll(".images-scrolling-desktop__media-wrapper > :not(:first-child)"))),
            (this._mainImage = this.querySelector(".images-scrolling-desktop__media-wrapper > :first-child")),
            (this._contentItems = Array.from(this.querySelectorAll(".images-scrolling__content"))),
            this._imageToTransitionItems.length > 0 && window.addEventListener("scroll", throttle2(this._onScroll.bind(this))));
  }
  _reveal() {    
    Array.from(this.querySelectorAll('[reveal-on-scroll="true"]')).forEach((heading) => {
      hi(...getHeadingKeyframe(heading));
    });
  }
  _onScroll() {
    const imageRect = this._mainImage.getBoundingClientRect(),
        imageBottom = imageRect.bottom,
        imageEffect = this.getAttribute("scrolling-experience");
        
    for (const [index, contentItem] of this._contentItems.entries()) {
        const contentItemRect = contentItem.getBoundingClientRect(),
            image = this._imageToTransitionItems[index - 1],
            content = this._contentItems[index];            
        if (contentItemRect.top < imageBottom - imageRect.height * 0.15 && contentItemRect.bottom > imageBottom) {
            image &&
                !image.classList.contains("is-visible") &&
                (image.classList.add("is-visible"),
                imageEffect === "fade"
                    ? Yr([
                          [image, { opacity: [null, 1] }, { duration: 0.2 }],
                          [content, { opacity: [null, 1] }, { duration: 0.45, at: "<" }],
                      ])
                    : Yr([
                          [image, { opacity: [null, 1], clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"] }, { duration: 0.35, easing: [0.99, 0.01, 0.5, 0.94], opacity: { duration: 0 } }],
                          [content, { opacity: [null, 1] }, { duration: 0.45, at: "<" }],
                      ]));
            break;
        }
        if (contentItemRect.top > imageBottom - imageRect.height * 0.15) {
            image &&
                image.classList.contains("is-visible") &&
                (image.classList.remove("is-visible"),
                imageEffect === "fade"
                    ? Yr([
                          [image, { opacity: [null, 0] }, { duration: 0.2 }],
                          [content, { opacity: [null, 0] }, { duration: 0.2, at: "<" }],
                      ])
                    : Yr([
                          [image, { opacity: [null, 1], clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"] }, { duration: 0.35, easing: [0.99, 0.01, 0.5, 0.94], opacity: { duration: 0 } }],
                          [content, { opacity: [null, 0] }, { duration: 0.2, at: "<" }],
                      ]));
            break;
        }
    }
  }
  };
  window.customElements.get("images-with-text-scrolling") || window.customElements.define("images-with-text-scrolling", ImagesWithTextScrolling);

